import { n as N } from "./common-Cd7R8f1s.js";
import { n as S } from "./Logger-CmiOOsKC.js";
import { b as Ot, t as Z } from "./tracebehavior-5_qSKjs6.js";
import { Ct as kt, St as _, Y as ne, ct as Re, p as Ct, st as Mt, wt as et } from "./SceneCreation-DVCYLXYF.js";
import { a as It, n as Bt, t as J } from "./TransitionManager-BD_yHXIb.js";
import { t as Nt } from "./bindingValues-BuN2Qy2j.js";
import { a as tt, c as Vt, i as Rt, o as Ft, r as st, s as Dt } from "./playable-tG_Q2o5X.js";
import { n as nt, t as Gt } from "./boxcollider-DfK5pGI3.js";
import { t as V, u as fe } from "./properties-C_pgb9zu.js";
import "./imageanchordata-dKT5zAcc.js";
import { Quaternion as H, Vector2 as rt, Vector3 as O } from "@babylonjs/core/Maths/math.vector.js";
import "@babylonjs/core/Animations/animation.js";
import { Observable as re } from "@babylonjs/core/Misc/observable.js";
import "@babylonjs/core/Engines/Extensions/engine.videoTexture.js";
import { VideoTexture as $t } from "@babylonjs/core/Materials/Textures/videoTexture.js";
import { Mesh as ce } from "@babylonjs/core/Meshes/mesh.js";
import { MeshBuilder as z } from "@babylonjs/core/Meshes/meshBuilder.js";
import { StandardMaterial as Me } from "@babylonjs/core/Materials/standardMaterial.js";
import { CreatePlaneVertexData as Fe } from "@babylonjs/core/Meshes/Builders/planeBuilder.js";
import { PointerEventTypes as L, PointerInfo as Lt } from "@babylonjs/core/Events/pointerEvents.js";
import { AdvancedDynamicTexture as ge } from "@babylonjs/gui/2D/advancedDynamicTexture.js";
import { Ellipse as De } from "@babylonjs/gui/2D/controls/ellipse.js";
import { TextBlock as Ge } from "@babylonjs/gui/2D/controls/textBlock.js";
import { Rectangle as _e } from "@babylonjs/gui/2D/controls/rectangle.js";
import { Control as D } from "@babylonjs/gui/2D/controls/control.js";
import { Color3 as Ee, Color4 as jt } from "@babylonjs/core/Maths/math.color.js";
import { Material as we } from "@babylonjs/core/Materials/material.js";
import { VertexData as it } from "@babylonjs/core/Meshes/mesh.vertexData.js";
import { AbstractMesh as $e } from "@babylonjs/core/Meshes/abstractMesh.js";
import { ArcRotateCamera as xe } from "@babylonjs/core/Cameras/arcRotateCamera.js";
import { ArcRotateCameraMovement as Ut } from "@babylonjs/core/Cameras/arcRotateCameraMovement.js";
import "@babylonjs/core/Animations/animatable.js";
import { FramingBehavior as zt } from "@babylonjs/core/Behaviors/Cameras/framingBehavior.js";
import { TransformNode as Le } from "@babylonjs/core/Meshes/transformNode.js";
import { CreateSphere as je } from "@babylonjs/core/Meshes/Builders/sphereBuilder.js";
import { FlowGraphCoordinator as at } from "@babylonjs/core/FlowGraph/flowGraphCoordinator.js";
import { FlowGraphExecutionBlock as Q } from "@babylonjs/core/FlowGraph/flowGraphExecutionBlock.js";
import { FlowGraphEventBlock as he } from "@babylonjs/core/FlowGraph/flowGraphEventBlock.js";
import { PickingInfo as Ht } from "@babylonjs/core/Collisions/pickingInfo.js";
import { FlowGraphReceiveCustomEventBlock as Ue } from "@babylonjs/core/FlowGraph/Blocks/Event/flowGraphReceiveCustomEventBlock.js";
import { FlowGraphSendCustomEventBlock as Wt } from "@babylonjs/core/FlowGraph/Blocks/Event/flowGraphSendCustomEventBlock.js";
import { FlowGraphBranchBlock as Xt } from "@babylonjs/core/FlowGraph/Blocks/Execution/ControlFlow/flowGraphBranchBlock.js";
import { FlowGraphSequenceBlock as qt } from "@babylonjs/core/FlowGraph/Blocks/Execution/ControlFlow/flowGraphSequenceBlock.js";
import { FlowGraphSetDelayBlock as Kt } from "@babylonjs/core/FlowGraph/Blocks/Execution/ControlFlow/flowGraphSetDelayBlock.js";
import { FlowGraphCancelDelayBlock as Qt } from "@babylonjs/core/FlowGraph/Blocks/Execution/ControlFlow/flowGraphCancelDelayBlock.js";
import { FlowGraphAddBlock as Zt, FlowGraphBitwiseAndBlock as Yt, FlowGraphBitwiseNotBlock as Jt, FlowGraphBitwiseOrBlock as es, FlowGraphDivideBlock as ts, FlowGraphEqualityBlock as ss, FlowGraphFloorBlock as ns, FlowGraphGreaterThanBlock as rs, FlowGraphGreaterThanOrEqualBlock as is, FlowGraphLessThanBlock as as, FlowGraphLessThanOrEqualBlock as os, FlowGraphMaxBlock as cs, FlowGraphMinBlock as ls, FlowGraphMultiplyBlock as us, FlowGraphPowerBlock as hs, FlowGraphRandomBlock as ds, FlowGraphSubtractBlock as ps } from "@babylonjs/core/FlowGraph/Blocks/Data/Math/flowGraphMathBlocks.js";
import { FlowGraphCombineVector3Block as fs } from "@babylonjs/core/FlowGraph/Blocks/Data/Math/flowGraphMathCombineExtractBlocks.js";
import { FlowGraphTypes as me, RichTypeAny as R, RichTypeBoolean as F, RichTypeNumber as M, RichTypeString as W } from "@babylonjs/core/FlowGraph/flowGraphRichTypes.js";
import { FlowGraphGetVariableBlock as gs } from "@babylonjs/core/FlowGraph/Blocks/Data/flowGraphGetVariableBlock.js";
import { FlowGraphSetVariableBlock as _s } from "@babylonjs/core/FlowGraph/Blocks/Execution/flowGraphSetVariableBlock.js";
import { FlowGraphBlock as B } from "@babylonjs/core/FlowGraph/flowGraphBlock.js";
import { FlowGraphExecutionBlockWithOutSignal as I } from "@babylonjs/core/FlowGraph/flowGraphExecutionBlockWithOutSignal.js";
import { FlowGraphConditionalDataBlock as ms } from "@babylonjs/core/FlowGraph/Blocks/Data/flowGraphConditionalDataBlock.js";
import { FlowGraphAsyncExecutionBlock as Ie } from "@babylonjs/core/FlowGraph/flowGraphAsyncExecutionBlock.js";
import { FlowGraphMeshPickEventBlock as vs } from "@babylonjs/core/FlowGraph/Blocks/Event/flowGraphMeshPickEventBlock.js";
import { FlowGraphPointerOverEventBlock as bs } from "@babylonjs/core/FlowGraph/Blocks/Event/flowGraphPointerOverEventBlock.js";
import { FlowGraphPointerOutEventBlock as ys } from "@babylonjs/core/FlowGraph/Blocks/Event/flowGraphPointerOutEventBlock.js";
import { FlowGraphSceneTickEventBlock as Ss } from "@babylonjs/core/FlowGraph/Blocks/Event/flowGraphSceneTickEventBlock.js";
var ze = 5e-5;
function He(e) {
  if (e <= ze) return 8;
  const t = Math.PI / 4 / Math.acos(1 - ze / e);
  return Math.min(32, Math.max(8, Math.ceil(t)));
}
function Ts(e) {
  return e === 2 ? [
    0,
    1,
    2
  ] : e === 0 ? [
    1,
    2,
    0
  ] : [
    2,
    0,
    1
  ];
}
var ot = {
  x: 0,
  y: 1,
  z: 2
}, Ps = /(?:^|[/:])(?:bevel|primitive)_(?:cube|plane)(?:_[0-9a-f]{8})?\.glb$/, Es = /(?:^|[/:])(?:bevel|primitive)_plane(?:_[0-9a-f]{8})?\.glb$/, ei = class extends Z {
  static behaviorType = "Bevel";
  _mesh = null;
  _original = null;
  _host = null;
  _builtScale = null;
  _scaleObserver = null;
  _warnedUnsupportedHost = !1;
  constructor(e, t) {
    super(e, t), this.validate(this.getAuthored()), this._resolved = this._resolveAll();
  }
  _migrateLegacyRadius(e) {
    const t = e, s = t.radius;
    if (s === void 0 || (delete t.radius, typeof s != "number" || !Number.isFinite(s) || s <= 0) || (e.cornerRadius ?? 0) > 0 || e.pill === !0) return;
    const n = this.sceneObject.transform.scaling, r = [
      Math.abs(n.x),
      Math.abs(n.y),
      Math.abs(n.z)
    ], i = Es.test(this.sceneObject.src) ? 1 : e.axis && e.axis !== "auto" ? ot[e.axis] : r.indexOf(Math.min(...r)), a = r.filter((c, l) => l !== i), o = Math.min(...a) || 1;
    s >= 0.5 && (e.pill = !0), e.cornerRadius = Math.min(s, 0.5) * o, S.warn(`[Bevel] "${this.sceneObject.name}": legacy radius ${s} (fraction of the smaller side) → cornerRadius ${e.cornerRadius.toFixed(4)} m${e.pill ? " + pill" : ""}. Re-save to keep it.`);
  }
  validate(e) {
    const t = [];
    return this._migrateLegacyRadius(e), e.cornerRadius !== void 0 && (typeof e.cornerRadius != "number" || !Number.isFinite(e.cornerRadius) || e.cornerRadius < 0) && t.push({
      field: "cornerRadius",
      message: "cornerRadius must be a non-negative number (meters)",
      code: "INVALID_RADIUS"
    }), e.pill !== void 0 && typeof e.pill != "boolean" && t.push({
      field: "pill",
      message: "pill must be a boolean",
      code: "INVALID_PILL"
    }), e.axis !== void 0 && ![
      "auto",
      "x",
      "y",
      "z"
    ].includes(e.axis) && t.push({
      field: "axis",
      message: 'Axis must be "auto", "x", "y" or "z"',
      code: "INVALID_AXIS"
    }), e.edges !== void 0 && !["corners", "all"].includes(e.edges) && t.push({
      field: "edges",
      message: 'Edges must be "corners" or "all"',
      code: "INVALID_EDGES"
    }), t;
  }
  onAttach() {
    this._apply(), this._watchNodeScale();
  }
  async applyCommit() {
    this._apply();
  }
  onDetach() {
    this._scaleObserver && (this._scaleObserver.remove(), this._scaleObserver = null), this._mesh && !this._mesh.isDisposed() && this._original && this._original.applyToMesh(this._mesh), this._mesh = null, this._original = null, this._host = null, this._builtScale = null;
  }
  _watchNodeScale() {
    this._scaleObserver || !this.sceneObject?.transform || (this._scaleObserver = this.sceneObject.transform.onAfterWorldMatrixUpdateObservable.add((e) => {
      const t = e.scaling, s = this._builtScale;
      s && t.x === s.x && t.y === s.y && t.z === s.z || (s && Ot(this.sceneObject), this._apply());
    }));
  }
  _apply() {
    if (!this._hostSupported()) return;
    const e = this._resolveMesh(), t = this._host;
    if (!e || !t) return;
    const s = this.sceneObject.transform.scaling;
    this._builtScale = s.clone();
    const n = Be(this._resolved, t, s);
    if (!n) {
      this._original && this._original.applyToMesh(e);
      return;
    }
    n.applyToMesh(e), (e.material?.sideOrientation ?? e.sideOrientation) === we.CounterClockWiseSideOrientation && e.flipFaces(), e.refreshBoundingInfo();
  }
  _hostSupported() {
    const e = this.sceneObject.src;
    return !e || Ps.test(e) ? !0 : (this._warnedUnsupportedHost || (this._warnedUnsupportedHost = !0, S.warn(`[Bevel] "${this.sceneObject.name}" src "${e}" is not a cube/plane primitive — Bevel only rounds primitive slabs; leaving the mesh untouched`)), !1);
  }
  _resolveMesh() {
    if (this._mesh && !this._mesh.isDisposed()) return this._mesh;
    const e = kt(this.sceneObject.transform)[0];
    return e instanceof ce ? (e.geometry && e.geometry.meshes.length > 1 && e.makeGeometryUnique(), this._mesh = e, this._original = it.ExtractFromMesh(e), this._host = xs(this._original), e) : (S.warn(`[Bevel] "${this.sceneObject.name}" has no geometry-bearing mesh to bevel (expected a primitive src)`), null);
  }
};
function ti(e, t, s) {
  return Be(e, s === "plane" ? {
    extents: [
      1,
      0,
      1
    ],
    center: [
      0,
      0,
      0
    ],
    flatAxis: 1,
    flatSign: 1
  } : {
    extents: [
      1,
      1,
      1
    ],
    center: [
      0,
      0,
      0
    ],
    flatAxis: null,
    flatSign: 1
  }, {
    x: t[0],
    y: t[1],
    z: t[2]
  });
}
function We(e, t) {
  return Be({
    cornerRadius: e,
    axis: "auto",
    edges: "corners"
  }, {
    extents: [
      1,
      1,
      0
    ],
    center: [
      0,
      0,
      0
    ],
    flatAxis: 2,
    flatSign: -1
  }, {
    x: t[0],
    y: t[1],
    z: 0
  });
}
function Be(e, t, s) {
  const n = Ts(ws(e.axis, t, s)), r = (m) => Math.max(Math.abs([
    s.x,
    s.y,
    s.z
  ][m]) * (t.extents[m] || 1), 1e-6), i = r(n[0]), a = r(n[1]), o = r(n[2]), c = Math.min(i, a) / 2, l = Math.min(e.pill ? c : e.cornerRadius ?? 0, c);
  if (!(l > 1e-7)) return null;
  const h = Math.min(l / i, 0.5), v = Math.min(l / a, 0.5), p = t.flatAxis !== null ? {
    coord: t.center[t.flatAxis],
    sign: t.flatSign
  } : null;
  let b = null;
  if (!p && e.edges === "all") {
    const m = Math.min(l, o / 2);
    m > 1e-7 && (b = {
      u: Math.min(m / i, h),
      v: Math.min(m / a, v),
      w: Math.min(m / o, 0.5),
      samples: He(m)
    });
  }
  return As(h, v, He(l), n, p, b);
}
function ws(e, t, s) {
  if (t.flatAxis !== null) return t.flatAxis;
  if (e && e !== "auto") return ot[e];
  const n = [
    Math.abs(s.x) * (t.extents[0] || 1),
    Math.abs(s.y) * (t.extents[1] || 1),
    Math.abs(s.z) * (t.extents[2] || 1)
  ];
  let r = 2;
  return n[1] < n[r] && (r = 1), n[0] < n[r] && (r = 0), r;
}
function xs(e) {
  const t = e.positions ?? [], s = [
    1 / 0,
    1 / 0,
    1 / 0
  ], n = [
    -1 / 0,
    -1 / 0,
    -1 / 0
  ];
  for (let c = 0; c < t.length; c += 3) for (let l = 0; l < 3; l++)
    s[l] = Math.min(s[l], t[c + l]), n[l] = Math.max(n[l], t[c + l]);
  const r = [
    n[0] - s[0],
    n[1] - s[1],
    n[2] - s[2]
  ], i = [
    (n[0] + s[0]) / 2,
    (n[1] + s[1]) / 2,
    (n[2] + s[2]) / 2
  ];
  let a = null;
  for (const c of [
    0,
    1,
    2
  ]) if (Number.isFinite(r[c]) && r[c] < 1e-6) {
    a = c;
    break;
  }
  let o = 1;
  if (a !== null) {
    const c = e.normals ?? [];
    let l = 0;
    for (let h = 0; h < c.length; h += 3) l += c[h + a];
    o = l < 0 ? -1 : 1;
  }
  return {
    extents: r,
    center: i,
    flatAxis: a,
    flatSign: o
  };
}
function ve(e, t, s, n = 0.5, r = 0.5) {
  const i = n - e, a = r - t, o = [
    [
      i,
      -a,
      -Math.PI / 2
    ],
    [
      i,
      a,
      0
    ],
    [
      -i,
      a,
      Math.PI / 2
    ],
    [
      -i,
      -a,
      Math.PI
    ]
  ], c = [];
  for (const [l, h, v] of o) for (let p = 0; p <= s; p++) {
    const b = v + p / s * (Math.PI / 2), m = Math.cos(b), E = Math.sin(b), f = e > 1e-9 ? m / e : m, u = t > 1e-9 ? E / t : E, d = Math.hypot(f, u) || 1;
    c.push({
      u: l + e * m,
      v: h + t * E,
      nu: f / d,
      nv: u / d
    });
  }
  return c;
}
function As(e, t, s, n, r, i) {
  const a = [], o = [], c = [], l = [], h = (u, d, g, w, y, P) => {
    const T = [
      0,
      0,
      0
    ], A = [
      0,
      0,
      0
    ];
    T[n[0]] = u, T[n[1]] = d, T[n[2]] = g;
    const k = Math.hypot(w, y, P) || 1;
    return A[n[0]] = w / k, A[n[1]] = y / k, A[n[2]] = P / k, a.push(T[0], T[1], T[2]), o.push(A[0], A[1], A[2]), c.push(u + 0.5, d + 0.5), a.length / 3 - 1;
  }, v = (u, d, g) => {
    const w = d.length;
    for (let y = 0; y < w; y++) {
      const P = (y + 1) % w;
      g > 0 ? l.push(u, d[P], d[y]) : l.push(u, d[y], d[P]);
    }
  }, p = (u, d) => {
    const g = u.length;
    for (let w = 0; w < g; w++) {
      const y = (w + 1) % g;
      l.push(u[w], u[y], d[y], u[w], d[y], d[w]);
    }
  }, b = () => {
    const u = new it();
    return u.positions = a, u.normals = o, u.uvs = c, u.indices = l, u;
  };
  if (r) {
    const u = ve(e, t, s);
    return v(h(0, 0, r.coord, 0, 0, r.sign), u.map((d) => h(d.u, d.v, r.coord, 0, 0, r.sign)), r.sign), b();
  }
  if (!i) {
    const u = ve(e, t, s);
    for (const d of [1, -1]) v(h(0, 0, 0.5 * d, 0, 0, d), u.map((g) => h(g.u, g.v, 0.5 * d, 0, 0, d)), d);
    return p(u.map((d) => h(d.u, d.v, 0.5, d.nu, d.nv, 0)), u.map((d) => h(d.u, d.v, -0.5, d.nu, d.nv, 0))), b();
  }
  const m = ve(Math.max(e - i.u, 0), Math.max(t - i.v, 0), s, 0.5 - i.u, 0.5 - i.v), E = [], f = (u, d) => m.map((g) => h(g.u + g.nu * i.u * Math.cos(u), g.v + g.nv * i.v * Math.cos(u), d * (0.5 - i.w + i.w * Math.sin(u)), g.nu * Math.cos(u) / i.u, g.nv * Math.cos(u) / i.v, d * Math.sin(u) / i.w));
  for (let u = i.samples; u >= 0; u--) E.push(f(u / i.samples * (Math.PI / 2), 1));
  for (let u = 0; u <= i.samples; u++) E.push(f(u / i.samples * (Math.PI / 2), -1));
  for (let u = 0; u + 1 < E.length; u++) p(E[u], E[u + 1]);
  return v(h(0, 0, 0.5, 0, 0, 1), E[0], 1), v(h(0, 0, -0.5, 0, 0, -1), E[E.length - 1], -1), b();
}
function Xe(e) {
  const t = Array.from(e.positions ?? []), s = Array.from(e.normals ?? []), n = Array.from(e.uvs ?? []), r = Array.from(e.indices ?? []), i = t.length / 3;
  e.positions = t.concat(t), e.normals = s.concat(s.map((o) => -o)), e.uvs = n.concat(n);
  const a = [];
  for (let o = 0; o + 2 < r.length; o += 3) a.push(i + r[o], i + r[o + 2], i + r[o + 1]);
  return e.indices = r.concat(a), e;
}
var Os = class extends Z {
  onAspectChangedObservable = new re();
  onOrientationChangedObservable = new re();
  onFitChangedObservable = new re();
  aspectKnown = !1;
  _fittedScale = null;
  _fitObserver = null;
  onQuadFitUpdated(e, t) {
  }
  getFittedRect() {
    const e = this.getFitQuad()?.scaling;
    return {
      sx: e?.x ?? 1,
      sy: e?.y ?? 1
    };
  }
  updateQuadFit() {
    const e = this.getFitQuad();
    if (!e) return;
    const t = this.sceneObject?.transform?.scaling, s = this.orientation === N.Horizontal ? t?.z : t?.y, n = t && s ? Math.abs(t.x / s) : 1, r = this.aspectRatio / (n || 1), i = this.aspectKnown && this.getFitMode() === "cover", a = this.aspectKnown && !i ? Math.min(1, r) : 1, o = this.aspectKnown && !i ? Math.min(1, 1 / r) : 1;
    e.scaling = new O(a, o, 1), t && (this._fittedScale = t.clone()), this.applyQuadShape(e, Math.abs((t?.x ?? 1) * a), Math.abs((s ?? 1) * o), i ? Math.min(1, 1 / r) : 1, i ? Math.min(1, r) : 1), this.onQuadFitUpdated(a, o), this.applyBackCard(e), this.onFitChangedObservable.notifyObservers();
  }
  _cropWindow = {
    u: 1,
    v: 1
  };
  _shape = null;
  _backFaces = !1;
  _backCard = null;
  _backCardMat = null;
  _cardHex = null;
  _cardGeometryDirty = !1;
  validateFit(e, t) {
    e !== void 0 && e !== "contain" && e !== "cover" && t.push({
      field: "fit",
      message: "fit must be 'contain' or 'cover'",
      code: "INVALID_FIT"
    });
  }
  validatePill(e, t) {
    e !== void 0 && typeof e != "boolean" && t.push({
      field: "pill",
      message: "pill must be a boolean",
      code: "INVALID_PILL"
    });
  }
  validateBack(e, t) {
    e !== void 0 && e !== "none" && e !== "picture" && e !== "color" && t.push({
      field: "back",
      message: "back must be 'none', 'picture' or 'color'",
      code: "INVALID_BACK"
    });
  }
  validateBackColor(e, t) {
    e !== void 0 && (typeof e != "string" || !Nt.test(e)) && t.push({
      field: "backColor",
      message: "backColor must be #RRGGBB or #RRGGBBAA",
      code: "INVALID_BACK_COLOR"
    });
  }
  validateCornerRadius(e, t) {
    e !== void 0 && (typeof e != "number" || !Number.isFinite(e) || e < 0) && t.push({
      field: "cornerRadius",
      message: "cornerRadius must be a non-negative number (meters)",
      code: "INVALID_RADIUS"
    });
  }
  applyQuadShape(e, t, s, n, r) {
    const i = Math.min(t, s) / 2, a = this.getPill() ? i : Math.max(this.getCornerRadius(), 0), o = Math.min(a, i), c = o > 1e-7 && t > 1e-6 && s > 1e-6, l = this._shape, h = c ? !l || Math.abs(l.radius - o) > 1e-9 || Math.abs(l.w - t) > 1e-6 || Math.abs(l.h - s) > 1e-6 : l !== null, v = this.getBack() === "picture", p = v !== this._backFaces, b = this._cropWindow;
    if (!h && !p && b.u === n && b.v === r) return;
    if (this._cropWindow = {
      u: n,
      v: r
    }, h || p) {
      const d = c ? We(o, [t, s]) : null;
      this._shape = d ? {
        radius: o,
        w: t,
        h: s
      } : null, this._backFaces = v, this._cardGeometryDirty = !0;
      const g = d ?? Fe({ size: 1 });
      (v ? Xe(g) : g).applyToMesh(e);
    }
    const m = e.getVerticesData("position"), E = e.getVerticesData("uv");
    if (!m || !E) return;
    const f = (1 - n) / 2, u = (1 - r) / 2;
    for (let d = 0, g = 0; g + 1 < E.length; d += 3, g += 2)
      E[g] = f + (0.5 - m[d]) * n, E[g + 1] = u + (0.5 - m[d + 1]) * r;
    e.setVerticesData("uv", E);
  }
  applyBackCard(e) {
    if (this.getBack() !== "color") {
      this.disposeBackCard();
      return;
    }
    if ((!this._backCard || this._backCard.isDisposed()) && (this.disposeBackCard(), this._backCard = new ce(`${e.name}_back`, e.getScene()), this._backCard.parent = e, this._backCard.position.set(0, 0, 5e-3), this._backCardMat = new Me(`${e.name}_back_mat`, e.getScene()), this._backCardMat.disableLighting = !0, this._backCardMat.diffuseColor = Ee.Black(), this._backCard.material = this._backCardMat, this._cardGeometryDirty = !0, this.sceneObject.traceScene.refreshMeshPickability?.(this.sceneObject)), this._cardGeometryDirty) {
      const n = this._shape;
      Xe((n ? We(n.radius, [n.w, n.h]) : null) ?? Fe({ size: 1 })).applyToMesh(this._backCard), this._cardGeometryDirty = !1;
    }
    const t = this.getBackColor();
    if (t === this._cardHex) return;
    this._cardHex = t;
    const s = jt.FromHexString(t.length === 7 ? t + "FF" : t);
    this._backCardMat.emissiveColor = new Ee(s.r, s.g, s.b), this._backCardMat.alpha = s.a, this._backCardMat.transparencyMode = s.a < 1 ? we.MATERIAL_ALPHABLEND : we.MATERIAL_OPAQUE, this._backCardMat.needDepthPrePass = !1, this._backCard.metadata = {
      ...this._backCard.metadata,
      colorAlpha: s.a
    }, this.sceneObject.onOwnedMeshesChangedObservable.notifyObservers();
  }
  disposeBackCard() {
    this._backCard?.dispose(), this._backCard = null, this._backCardMat?.dispose(), this._backCardMat = null, this._cardHex = null;
  }
  watchNodeScaleForFit() {
    this._fitObserver || !this.sceneObject?.transform || (this._fitObserver = this.sceneObject.transform.onAfterWorldMatrixUpdateObservable.add((e) => {
      const t = e.scaling, s = this._fittedScale;
      s && t.x === s.x && t.y === s.y && t.z === s.z || this.updateQuadFit();
    }));
  }
  disposeFitWatcher() {
    this._fitObserver && (this._fitObserver.remove(), this._fitObserver = null), this._fittedScale = null, this._cropWindow = {
      u: 1,
      v: 1
    }, this._shape = null, this._backFaces = !1;
  }
}, ks = "__controls", be = 0.15, qe = 0.85;
function Ke(e) {
  return !isFinite(e) || e < 0 ? "0:00" : `${Math.floor(e / 60)}:${Math.floor(e % 60).toString().padStart(2, "0")}`;
}
var ee = /* @__PURE__ */ new Map(), Cs = class extends Os {
  static behaviorType = "Video";
  videoTexture;
  quad;
  videoMaterial = null;
  aspectRatio;
  orientation = N.Vertical;
  onMediaElementReadyObservable = new re();
  _resolvedVideoUrl = null;
  _videoLoaded = !1;
  _renderObserver = null;
  _loadingPlane = null;
  _loadingTexture = null;
  _spinnerObserver = null;
  _playButtonPlane = null;
  _playButtonTexture = null;
  _pickerMesh = null;
  _controlsPlane = null;
  _controlsFittedWidth = 0;
  _controlsTexture = null;
  _controlsUpdateObserver = null;
  _controlsPointerObserver = null;
  _progressFill = null;
  _timeText = null;
  _isScrubbing = !1;
  _controlsConsumedPointer = !1;
  _authorAspectOnDetect = !1;
  getFitQuad() {
    return this.quad;
  }
  getFitMode() {
    return this._resolved.fit ?? "contain";
  }
  getCornerRadius() {
    return this._resolved.cornerRadius ?? 0;
  }
  getPill() {
    return this._resolved.pill === !0;
  }
  getBack() {
    return this._resolved.back ?? "none";
  }
  getBackColor() {
    return this._resolved.backColor ?? "#FFFFFF";
  }
  constructor(e, t) {
    super(e, t), this.videoTexture = null, this.quad = null, this.aspectRatio = 1;
  }
  validate(e) {
    const t = [];
    return e.aspect !== void 0 && (typeof e.aspect != "number" || e.aspect <= 0) && t.push({
      field: "aspect",
      message: "Aspect ratio must be a positive number",
      code: "INVALID_ASPECT"
    }), this.validateFit(e.fit, t), this.validateCornerRadius(e.cornerRadius, t), this.validatePill(e.pill, t), this.validateBack(e.back, t), this.validateBackColor(e.backColor, t), t;
  }
  async applyCommit() {
    if (this.applyOrientation(), this._isTapToPlay && this._videoLoaded) {
      if (!this._playButtonPlane) {
        this._showPlayButton();
        const e = this.videoTexture?.video;
        this._updatePlayButtonIcon(!e || e.paused);
      }
    } else this._playButtonPlane && this._disposePlayButton();
    this._resolved.controls && this._videoLoaded ? this._controlsPlane || this._showControls() : this._controlsPlane && this._disposeControls();
  }
  getMediaElement() {
    return this.videoTexture?.video ?? null;
  }
  commitAspectWhenAvailable() {
    if (this.getAuthored().aspect === void 0) {
      if (this._resolved.aspect !== void 0) {
        this.commit({ aspect: this._resolved.aspect });
        return;
      }
      this._authorAspectOnDetect = !0;
    }
  }
  play() {
    const e = this.videoTexture?.video;
    e && (e.loop = this._resolved.loop !== !1, e.play().catch(() => {
    }), this._updatePlayButtonIcon(!1));
  }
  pause() {
    const e = this.videoTexture?.video;
    e && (e.pause(), this._updatePlayButtonIcon(!0));
  }
  setVolume(e) {
    const t = this.videoTexture?.video;
    t && (t.volume = Math.max(0, Math.min(1, e)));
  }
  isPlaying() {
    const e = this.videoTexture?.video;
    return !!e && !e.paused && !e.ended;
  }
  getVolume() {
    return this.videoTexture?.video?.volume ?? 1;
  }
  getClockTime() {
    return Vt(this.videoTexture?.video);
  }
  stop() {
    const e = this.videoTexture?.video;
    e && (e.pause(), e.currentTime = 0, this._updatePlayButtonIcon(!0));
  }
  onPointerEvent(e, t) {
    if (e === "select" && t && this._isTapToPlay) {
      if (this._controlsConsumedPointer) {
        this._controlsConsumedPointer = !1;
        return;
      }
      this._togglePlayback();
    }
  }
  claimsSelect() {
    return this._isTapToPlay;
  }
  seek(e, t = "absolute") {
    const s = this.videoTexture?.video;
    if (!s) return;
    const n = t === "relative" ? s.currentTime + e : e, r = s.duration;
    s.currentTime = Math.max(0, isFinite(r) ? Math.min(n, r) : n);
  }
  async captureCurrentFrame() {
    const e = this.videoTexture?.video;
    if (!e || !e.videoWidth || !e.videoHeight || e.readyState < 2) return null;
    const t = document.createElement("canvas");
    t.width = e.videoWidth, t.height = e.videoHeight;
    const s = t.getContext("2d");
    if (!s) return null;
    try {
      s.drawImage(e, 0, 0, t.width, t.height);
    } catch {
      return null;
    }
    return new Promise((n) => t.toBlob((r) => n(r), "image/png"));
  }
  onPlayModeChanged(e) {
    const t = this.videoTexture?.video;
    t && (e ? this._shouldAutoplay() ? this.play() : this._updatePlayButtonIcon(!0) : (t.pause(), t.currentTime = 0, this._updatePlayButtonIcon(!0)));
  }
  onEffectiveActiveChanged(e) {
    const t = this.videoTexture?.video;
    if (t) {
      if (!e) {
        t.pause(), this._updatePlayButtonIcon(!0);
        return;
      }
      this._shouldAutoplay() && this.play();
    }
  }
  _shouldAutoplay() {
    return this.playMode && this._resolved.playOnStart !== !1 && this.sceneObject.effectiveActive;
  }
  applyOrientation() {
    if (this.quad) {
      if (this.orientation = this._resolved.orientation ?? N.Vertical, this.orientation === N.Horizontal ? this.quad.rotation = new O(Math.PI / 2, Math.PI, 0) : this.quad.rotation = new O(0, Math.PI, 0), this._playButtonPlane && (this.orientation === N.Horizontal ? (this._playButtonPlane.rotation = new O(-Math.PI / 2, 0, 0), this._playButtonPlane.position.set(0, 0.01, 0)) : (this._playButtonPlane.rotation = new O(0, 0, 0), this._playButtonPlane.position.set(0, 0, 0.01))), this._controlsPlane) {
        const e = be;
        this.orientation === N.Horizontal ? (this._controlsPlane.rotation = new O(-Math.PI / 2, 0, 0), this._controlsPlane.position.set(0, 5e-3, 0.5 - e / 2)) : (this._controlsPlane.rotation = new O(0, 0, 0), this._controlsPlane.position.set(0, -0.5 + e / 2, 5e-3));
      }
      this.onOrientationChangedObservable.notifyObservers(this.orientation), this.updateQuadFit();
    }
  }
  onQuadFitUpdated(e, t) {
    if (this._pickerMesh && this._pickerMesh.scaling.set(e, t, 1), this._controlsPlane) if (Math.abs(this._controlsFittedWidth - e) > 1e-4)
      this._disposeControls(), this._showControls();
    else {
      const s = be;
      this.orientation === N.Horizontal ? this._controlsPlane.position.set(0, 5e-3, t / 2 - s / 2) : this._controlsPlane.position.set(0, -t / 2 + s / 2, 5e-3);
    }
  }
  load() {
    const e = this.sceneObject.name;
    this.aspectRatio = this._resolved.aspect ?? 1.33, this.aspectKnown = !0;
    const t = z.CreatePlane(e, { size: 1 }, this.scene);
    t.name = `${e}_mesh`;
    const s = t.getVerticesData("uv");
    if (s) {
      for (let r = 0; r < s.length; r += 2)
        s[r] = 1 - s[r], s[r + 1] = 1 - s[r + 1];
      t.setVerticesData("uv", s);
    }
    this.quad = t, this.applyOrientation(), this.sceneObject.addChild(t), this.watchNodeScaleForFit();
    const n = new Me(`${e}_video_mat`, this.scene);
    return n.diffuseColor.set(0, 0, 0), n.emissiveColor.set(0, 0, 0), t.material = n, this.videoMaterial = n, this.sceneObject.transform.isEnabled() ? this._loadVideo() : (this._renderObserver = this.scene.onBeforeRenderObservable.add(() => {
      !this._videoLoaded && this.sceneObject.transform.isEnabled() && (this._loadVideo(), this._renderObserver && (this.scene.onBeforeRenderObservable.remove(this._renderObserver), this._renderObserver = null));
    }), Promise.resolve());
  }
  _loadVideo(e) {
    if (this._videoLoaded || !this.quad || !this.videoMaterial) return Promise.resolve();
    this._videoLoaded = !0, S.debug(`loading video ${this.sceneObject.name}`), this._showLoadingSpinner();
    let t = e ?? (this.sceneObject.src || "");
    const s = this.resources.getAsset(t);
    if (s ? t = URL.createObjectURL(s) : t = this.resources.resolveAssetUrl(t) ?? t, !t)
      return S.warn(`[Video] No video source specified for "${this.sceneObject.name}"`), this._hideLoadingSpinner(), Promise.resolve();
    this._resolvedVideoUrl = t;
    const n = ee.get(t);
    let r;
    n ? (r = n.texture, n.refCount++, S.debug(`[Video] Reusing cached video texture for ${this.sceneObject.name} (refCount: ${n.refCount})`)) : (r = new $t(this.sceneObject.name, t, this.scene, !1, !0, void 0, { autoPlay: !1 }), ee.set(t, {
      texture: r,
      refCount: 1
    }), S.debug(`[Video] Created new video texture for ${this.sceneObject.name}`));
    const i = r.video;
    this.videoTexture = r, i.preload = "metadata";
    const a = this.videoMaterial;
    let o = !1;
    const c = () => {
      if (!o)
        if (o = !0, this._hideLoadingSpinner(), i.videoWidth && i.videoHeight && this._resolved.aspect === void 0 && (this.aspectRatio = i.videoWidth / i.videoHeight, this._resolved.aspect = this.aspectRatio, this.updateQuadFit(), this._authorAspectOnDetect && (this._authorAspectOnDetect = !1, this.commit({ aspect: this.aspectRatio })), this.onAspectChangedObservable.notifyObservers(this.aspectRatio)), a.diffuseTexture = r, a.emissiveTexture = r, a.diffuseColor.set(1, 1, 1), a.emissiveColor.set(1, 1, 1), this._isTapToPlay && this._showPlayButton(), this._resolved.controls && this._showControls(), this.onMediaElementReadyObservable.notifyObservers(i), this._shouldAutoplay()) {
          if (i.loop = this._resolved.loop !== !1, i.play().catch(() => {
          }), this._updatePlayButtonIcon(!1), i.readyState < 2) {
            const h = () => {
              this._shouldAutoplay() && i.play().catch(() => {
              });
            };
            i.addEventListener("pause", h, { once: !0 });
          }
        } else i.paused && (i.currentTime = 1e-3, this._updatePlayButtonIcon(!0));
    }, l = () => {
      S.warn(`[Video] Failed to load video for "${this.sceneObject.name}": ${i.error?.message || "unknown error"}`), this._hideLoadingSpinner();
    };
    i.addEventListener("error", l, { once: !0 });
    for (const h of i.querySelectorAll("source")) h.addEventListener("error", l, { once: !0 });
    return i.readyState >= 2 ? c() : (r.onLoadObservable.addOnce(() => {
      c();
    }), i.addEventListener("loadedmetadata", () => {
      c();
    }, { once: !0 })), Promise.resolve();
  }
  _showLoadingSpinner() {
    if (!this.quad || !this.scene) return;
    const e = z.CreatePlane("spinnerPlane", { size: 0.3 }, this.scene);
    e.parent = this.quad, e.position.z = -0.01, this._loadingPlane = e;
    const t = ge.CreateForMesh(e, 128, 128);
    this._loadingTexture = t;
    const s = new De("spinner");
    s.width = "100px", s.height = "100px", s.color = "white", s.thickness = 6, s.background = "transparent", s.arc = 0.75, t.addControl(s);
    let n = 0;
    this._spinnerObserver = this.scene.onBeforeRenderObservable.add(() => {
      n += 0.02, s.rotation = n;
    });
  }
  _hideLoadingSpinner() {
    this._spinnerObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._spinnerObserver), this._spinnerObserver = null), this._loadingTexture && (this._loadingTexture.dispose(), this._loadingTexture = null), this._loadingPlane && (this._loadingPlane.dispose(), this._loadingPlane = null);
  }
  get _isTapToPlay() {
    return this._resolved.userInteractible === !0 || this._resolved.controls === !0;
  }
  _showPlayButton() {
    if (!this.quad || !this.scene || this._playButtonPlane) return;
    const e = z.CreatePlane(`${this.sceneObject.name}_playBtn`, {
      size: 0.3,
      sideOrientation: ce.BACKSIDE
    }, this.scene);
    this.sceneObject.addChild(e), this.orientation === N.Horizontal ? (e.rotation = new O(-Math.PI / 2, 0, 0), e.position.set(0, 0.01, 0)) : e.position.set(0, 0, 0.01), e.isPickable = !1, this._playButtonPlane = e;
    const t = ge.CreateForMesh(e, 128, 128, !1);
    t.hasAlpha = !0, e.material && (e.material.backFaceCulling = !0), this._playButtonTexture = t;
    const s = new De("play-circle");
    s.width = "100px", s.height = "100px", s.thickness = 3, s.color = "white", s.background = "rgba(0, 0, 0, 0.5)", t.addControl(s);
    const n = new Ge("play-icon", "▶");
    n.color = "white", n.fontSize = 48, n.textHorizontalAlignment = D.HORIZONTAL_ALIGNMENT_CENTER, n.textVerticalAlignment = D.VERTICAL_ALIGNMENT_CENTER, n.paddingLeft = "6px", s.addControl(n), this._ensurePickerMesh();
  }
  _togglePlayback() {
    const e = this.videoTexture?.video;
    e && (e.paused ? (e.loop = this._resolved.loop !== !1, e.play().catch(() => {
    }), this._updatePlayButtonIcon(!1)) : (e.pause(), this._updatePlayButtonIcon(!0)));
  }
  _updatePlayButtonIcon(e) {
    this._playButtonPlane && this._playButtonPlane.setEnabled(e);
  }
  _showControls() {
    if (!this.quad || !this.scene || this._controlsPlane) return;
    const e = this.quad.scaling.x, t = this.quad.scaling.y, s = be, n = z.CreatePlane(`${this.sceneObject.name}${ks}`, {
      width: e,
      height: s,
      sideOrientation: ce.DOUBLESIDE
    }, this.scene);
    this._controlsFittedWidth = e, this.sceneObject.addChild(n), this.orientation === N.Horizontal ? (n.rotation = new O(-Math.PI / 2, 0, 0), n.position.set(0, 5e-3, t / 2 - s / 2)) : n.position.set(0, -t / 2 + s / 2, 5e-3), n.isPickable = !0, n.isNearGrabbable = !1, this._controlsPlane = n;
    const r = 1024, i = Math.min(512, Math.round(r * (s / Math.max(e, 0.05)))), a = ge.CreateForMesh(n, r, i, !1);
    a.hasAlpha = !0, n.material && (n.material.backFaceCulling = !0), this._controlsTexture = a;
    const o = new _e("controls-bg");
    o.width = 1, o.height = 1, o.thickness = 0, o.background = "rgba(0, 0, 0, 0.55)", a.addControl(o);
    const c = new _e("track");
    c.width = qe, c.height = 0.15, c.thickness = 0, c.background = "rgba(255, 255, 255, 0.25)", c.horizontalAlignment = D.HORIZONTAL_ALIGNMENT_CENTER, c.verticalAlignment = D.VERTICAL_ALIGNMENT_TOP, c.top = "15%", o.addControl(c);
    const l = new _e("fill");
    l.width = 0, l.height = 1, l.thickness = 0, l.background = "white", l.horizontalAlignment = D.HORIZONTAL_ALIGNMENT_LEFT, c.addControl(l), this._progressFill = l;
    const h = new Ge("time", "0:00 / 0:00");
    h.color = "white", h.fontSize = 0.35 * i, h.height = "60%", h.textHorizontalAlignment = D.HORIZONTAL_ALIGNMENT_RIGHT, h.textVerticalAlignment = D.VERTICAL_ALIGNMENT_CENTER, h.verticalAlignment = D.VERTICAL_ALIGNMENT_BOTTOM, h.paddingBottom = "25%", h.paddingRight = "8%", o.addControl(h), this._timeText = h, this._controlsUpdateObserver = this.scene.onBeforeRenderObservable.add(() => {
      const p = this.videoTexture?.video;
      if (!p || !this._progressFill) return;
      const b = p.duration > 0 ? p.currentTime / p.duration : 0;
      this._progressFill.width = b, this._timeText && (this._timeText.text = `${Ke(p.currentTime)} / ${Ke(p.duration)}`);
    });
    const v = (p) => p.ray ? this.scene.pickWithRay(p.ray, (b) => b === n) : this.scene.pick(p.localPosition.x, p.localPosition.y, (b) => b === n);
    this._controlsPointerObserver = this.scene.onPrePointerObservable.add((p) => {
      switch (p.type) {
        case L.POINTERDOWN: {
          if (this._isScrubbing) return;
          const b = v(p);
          if (!b?.hit || !b.getTextureCoordinates()) return;
          this._isScrubbing = !0, this._controlsConsumedPointer = !0, p.skipOnPointerObservable = !0, this.scene.activeCamera?.detachControl(), this._scrubFromUV(b.getTextureCoordinates().x);
          break;
        }
        case L.POINTERMOVE: {
          if (!this._isScrubbing) return;
          p.skipOnPointerObservable = !0;
          const b = v(p);
          if (b?.hit) {
            const m = b.getTextureCoordinates();
            m && this._scrubFromUV(m.x);
          }
          break;
        }
        case L.POINTERUP: {
          if (!this._isScrubbing) return;
          this._isScrubbing = !1, this._controlsConsumedPointer = !1, p.skipOnPointerObservable = !0;
          const b = this.scene.getEngine().getRenderingCanvas();
          this.scene.activeCamera && b && this.scene.activeCamera.attachControl(b, !0);
          break;
        }
      }
    });
  }
  _scrubFromUV(e) {
    const t = this.videoTexture?.video;
    if (!t || !t.duration) return;
    const s = (1 - qe) / 2, n = 1 - s;
    t.currentTime = Math.max(0, Math.min(1, (e - s) / (n - s))) * t.duration;
  }
  _disposeControls() {
    if (this._isScrubbing) {
      const e = this.scene?.getEngine().getRenderingCanvas();
      this.scene?.activeCamera && e && this.scene.activeCamera.attachControl(e, !0);
    }
    this._controlsUpdateObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._controlsUpdateObserver), this._controlsUpdateObserver = null), this._controlsPointerObserver && this.scene && (this.scene.onPrePointerObservable.remove(this._controlsPointerObserver), this._controlsPointerObserver = null), this._controlsTexture && (this._controlsTexture.dispose(), this._controlsTexture = null), this._controlsPlane && (this._controlsPlane.dispose(), this._controlsPlane = null), this._progressFill = null, this._timeText = null, this._isScrubbing = !1, this._controlsConsumedPointer = !1;
  }
  _disposePlayButton() {
    this._playButtonTexture && (this._playButtonTexture.dispose(), this._playButtonTexture = null), this._playButtonPlane && (this._playButtonPlane.dispose(), this._playButtonPlane = null), this._disposePickerMesh();
  }
  _ensurePickerMesh() {
    this._pickerMesh || this.sceneObject.getBehavior(Gt) || (this._pickerMesh = z.CreateBox(`${this.sceneObject.name}${nt}`, {
      width: 1,
      height: 1,
      depth: 0.01
    }, this.scene), this._pickerMesh.scaling.set(this.quad?.scaling.x ?? this.aspectRatio, this.quad?.scaling.y ?? 1, 1), this._pickerMesh.parent = this.sceneObject.transform, this._pickerMesh.visibility = 0, this._pickerMesh.isPickable = !0);
  }
  _disposePickerMesh() {
    this._pickerMesh && (this._pickerMesh.dispose(), this._pickerMesh = null);
  }
  _releaseVideoTexture() {
    const e = this.videoTexture?.video;
    if (e && e.pause(), this.videoTexture && this._resolvedVideoUrl) {
      const t = ee.get(this._resolvedVideoUrl);
      t ? (t.refCount--, t.refCount <= 0 ? (t.texture.dispose(), ee.delete(this._resolvedVideoUrl), S.debug(`[Video] Disposed cached video texture for ${this._resolvedVideoUrl}`)) : S.debug(`[Video] Decremented refCount for ${this._resolvedVideoUrl} (refCount: ${t.refCount})`)) : this.videoTexture.dispose();
    }
    this.videoTexture = null, this._resolvedVideoUrl = null, this._videoLoaded = !1;
  }
  setSource(e) {
    if (!e)
      return S.warn(`[Video] setSource called with empty URL on "${this.sceneObject.name}"`), Promise.resolve();
    const t = this.resources.getAsset(e) ? null : e;
    if (t && this._resolvedVideoUrl === t) return Promise.resolve();
    this._releaseVideoTexture(), this.videoMaterial && (this.videoMaterial.diffuseTexture = null, this.videoMaterial.emissiveTexture = null, this.videoMaterial.diffuseColor.set(0, 0, 0), this.videoMaterial.emissiveColor.set(0, 0, 0));
    const s = new Promise((n) => {
      this.onMediaElementReadyObservable.addOnce(() => n());
    });
    return this._loadVideo(e), s;
  }
  onDetach() {
    this.disposeFitWatcher(), this.disposeBackCard(), this._renderObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._renderObserver), this._renderObserver = null), this._hideLoadingSpinner(), this._disposePlayButton(), this._disposeControls(), this._releaseVideoTexture(), this.quad && (this.quad = null), this.videoMaterial = null, this.onMediaElementReadyObservable.clear(), S.debug(`Video ${this.sceneObject.name} detached and cleaned up.`);
  }
}, ye = "_pageEnter", si = "_pageExit";
function Ms(e) {
  return e.getBehavior("Properties")?.isStateGroupOwner() ?? !1;
}
function Is(e) {
  const t = [];
  return ct(e.getChildren(), t), t;
}
function ct(e, t) {
  for (const s of e)
    Ms(s) || (t.push(s), ct(s.getChildren(), t));
}
function Bs(e, t) {
  const s = e.getStateNames();
  return t === void 0 ? s.length > 0 : s.includes(t);
}
function le(e, t) {
  const s = [e];
  for (const n of Is(e)) {
    const r = n.getBehavior("Properties");
    r && Bs(r, t) && s.push(n);
  }
  return s;
}
function ni(e, t) {
  for (const s of le(e, t)) s.getBehavior("Properties")?.setState(t);
}
var Qe = /* @__PURE__ */ new WeakMap(), Ne = class ie extends Z {
  static behaviorType = "Pages";
  _autoplayTimer = null;
  _playing = !1;
  _activeIndex = 0;
  _pageStatesApplied = !1;
  _deactivationTimer = null;
  _deactivationGeneration = 0;
  _pendingSwap = null;
  _pagePropertyCleanup = null;
  constructor(t, s) {
    super(t, s), ie._migrateLoopAlias(this.getAuthored()) && (this._resolved = this._resolveAll());
  }
  static _migrateLoopAlias(t) {
    const s = t;
    return s.autoplayLoop === void 0 ? !1 : (s.loop = s.autoplayLoop, delete s.autoplayLoop, !0);
  }
  validate(t) {
    return ie._migrateLoopAlias(t), [];
  }
  onAttach(t) {
    const s = this.getPageNodes();
    if (s.length === 0 || this._resolved.pageSource === "firstChild") return;
    const n = s.map((r) => r.uniqueId).join(",");
    if (Qe.get(this.sceneObject) === n) {
      const r = s.findIndex((i) => i.isEnabled(!1));
      this._activeIndex = r < 0 ? 0 : r;
      return;
    }
    if (Qe.set(this.sceneObject, n), s.some((r, i) => r.isEnabled(!1) !== (i === 0))) {
      if (s.some((r) => this._hasBoundActive(r))) {
        this._activeIndex = 0;
        return;
      }
      S.warn(`[Pages] "${this.sceneObject.name}" was saved with a page other than the first visible — showing page 1; pages start at index 0`), s.forEach((r, i) => this._setPageActive(r, i === 0));
    }
    this._activeIndex = 0;
  }
  onPlayModeChanged(t) {
    if (t) {
      const s = this.sceneObject.traceScene, n = () => this._applyShowingPageStates();
      s?._deferStartEvent ? s._deferStartEvent(n) : n(), this._resolved.autoplay && this.play();
    } else
      this.stop(), this._pagePropertyCleanup && (J(this.sceneObject.babylonScene).cancel(`pageProps:${this.sceneObject.transform.uniqueId}`), this._pagePropertyCleanup(), this._pagePropertyCleanup = null);
  }
  onDetach() {
    this._stopAutoplay(), this._pendingSwap = null, this._pagePropertyCleanup?.(), this._pagePropertyCleanup = null, this._cancelDeactivationTimer();
  }
  _cancelDeactivationTimer() {
    this._deactivationTimer?.(), this._deactivationTimer = null;
  }
  play() {
    this._playing = !0;
    const t = this.getPageNodes();
    t.length > 0 && !t.some((s) => s.isEnabled(!1)) && this.showPage(this._activeIndex), this._startAutoplay();
  }
  pause() {
    this._playing = !1, this._stopAutoplay();
  }
  stop() {
    this._playing = !1, this._stopAutoplay(), this.showPage(0);
  }
  seek(t) {
    const s = this.getPageNodes().length;
    if (s === 0) return;
    const n = this._resolved.pageDuration ?? 5, r = Math.min(Math.floor(t / n), s - 1);
    this.showPage(r), this._playing && this._startAutoplay();
  }
  getTotalDuration() {
    const t = this.getPageNodes(), s = this._resolved.pageDuration ?? 5;
    return t.length * s;
  }
  async next(t = !0, s = !0) {
    const n = this.getPageNodes();
    if (n.length === 0) return;
    const r = this._cycleIndex(this._activeIndex, 1, n.length, t);
    r !== this._activeIndex && this.showPage(r, s);
  }
  async prev(t = !0, s = !0) {
    const n = this.getPageNodes();
    if (n.length === 0) return;
    const r = this._cycleIndex(this._activeIndex, -1, n.length, t);
    r !== this._activeIndex && this.showPage(r, s);
  }
  getPageCount() {
    return this.getPageNodes().length;
  }
  getPageNodes() {
    if (this._resolved.pageSource === "firstChild") return this._getNestedChildren();
    const t = this.sceneObject.getChildren(), s = this._resolved.shared;
    if (!s || s.length === 0) return t.map((r) => r.transform);
    const n = /* @__PURE__ */ new Set();
    for (const r of s) {
      const i = this.sceneObject.traceScene.resolveSceneObject(r, this.sceneObject);
      i && n.add(i);
    }
    return t.filter((r) => !n.has(r)).map((r) => r.transform);
  }
  getActivePageIndex() {
    return this._activeIndex;
  }
  showAllPages() {
    for (const t of this.getPageNodes()) this._setPageActive(t, !0);
  }
  isShowingAll() {
    const t = this.getPageNodes();
    if (t.length < 2) return !1;
    let s = 0;
    for (const n of t) if (n.isEnabled(!1) && (s++, s > 1))
      return !0;
    return !1;
  }
  _cycleIndex(t, s, n, r) {
    let i = t + s;
    return r ? i < 0 ? i = n - 1 : i >= n && (i = 0) : i = Math.max(0, Math.min(i, n - 1)), i;
  }
  _getNestedChildren() {
    const t = this.sceneObject.getChildTransforms();
    return t.length === 0 ? [] : t[0].getChildren();
  }
  showPage(t, s = !1) {
    const n = this.getPageNodes();
    if (n.length !== 0) {
      if (t = Math.max(0, Math.min(t, n.length - 1)), this._playing && (this._stopAutoplay(), this._scheduleNext((this._resolved.pageDuration ?? 5) * 1e3)), this._pendingSwap !== null) {
        const { targetIndex: r, departures: i } = this._pendingSwap;
        if (this._pendingSwap = null, r === t) {
          this._showPageWithStates(t, n, this._resolved.pages ?? [], s, !0);
          return;
        }
        if (s && t === this._activeIndex) for (const a of i) try {
          a.restoreSteadyState();
        } catch (o) {
          S.warn(`[Pages] departure repair failed: ${String(o)}`);
        }
      }
      if (s && this._resolved.transitionOrder === "exitFirst" && t !== this._activeIndex) {
        const r = this._activeIndex, i = r >= 0 && r < n.length ? this.sceneObject.traceScene.findSceneObjectByTransform(n[r]) : void 0, a = i ? this._collectExitCascade(i) : [];
        if (a.length > 0) {
          const o = ++this._deactivationGeneration;
          this._pendingSwap = {
            targetIndex: t,
            departures: a
          }, Promise.all(a.map((c) => c.requestExit())).then(() => {
            this._pendingSwap === null || o !== this._deactivationGeneration || (this._pendingSwap = null, this._playing && (this._stopAutoplay(), this._scheduleNext((this._resolved.pageDuration ?? 5) * 1e3)), this._showPageWithStates(t, n, this._resolved.pages ?? [], s, !0));
          });
          return;
        }
      }
      this._showPageWithStates(t, n, this._resolved.pages ?? [], s);
    }
  }
  wantsDescendantPointerEvents() {
    return this._resolved.advanceOnTap === !0;
  }
  onDescendantPointerEvent(t, s, n) {
    return t !== "select" || !s || this._resolved.advanceOnTap !== !0 ? !1 : (this.next(this._resolved.loop ?? !1, !0), !0);
  }
  _collectExitCascade(t) {
    const s = [], n = (r) => {
      const i = this._getExitSequence(r);
      if (i && s.push(i), r.getBehavior(ie) === null)
        for (const a of r.getChildren()) n(a);
    };
    return n(t), s;
  }
  _showPageWithStates(t, s, n, r, i = !1) {
    const a = this._activeIndex, o = this._pageStateMap(n, t), c = this._resolved.transition, l = {
      duration: c?.duration ?? 0.5,
      easing: c?.easing ?? "easeInOut",
      ...c?.delay !== void 0 ? { delay: c.delay } : {}
    }, h = this._allMappedPaths(n);
    this._activeIndex = t, this._pageStatesApplied = !0;
    const v = !r;
    this._cancelDeactivationTimer();
    const p = ++this._deactivationGeneration;
    if (r) {
      for (let T = 0; T < s.length; T++) T !== t && T !== a && this._setPageActive(s[T], !1);
      this._setPageActive(s[t], !0), a !== t && a >= 0 && a < s.length && this._setPageActive(s[a], !0);
    }
    const b = this._resolveTargets(h);
    let m = 0;
    const E = /* @__PURE__ */ new Set();
    for (const { member: T, props: A, state: k } of this._fanAssignments(o, b)) {
      E.add(T);
      const G = A.getStateTransition(k), $ = A.getActiveState(), Y = $ ? A.getStateTransition($) : void 0, q = G ?? Y ?? l;
      r && fe(q) && (m = Math.max(m, q.duration + (q.delay ?? 0))), A.setState(k, v, l);
    }
    for (const T of this._fanReverts(o, b, E)) {
      if (r) {
        const A = this._snapEnterState(T), k = (A ? T.getStateTransition(A) : void 0) ?? l;
        fe(k) && (m = Math.max(m, k.duration + (k.delay ?? 0)));
      }
      T.setState(void 0, v, l);
    }
    let f = l;
    if (r && a !== t) {
      const T = s[t], A = (T ? this.sceneObject.traceScene.findSceneObjectByTransform(T) : void 0)?.getBehavior(V);
      if (A) {
        const k = A.getStateTransition(ye);
        k && fe(k) && (f = k);
      }
    }
    if (r && a !== t) {
      const T = this._processPagePropertyCrossfade(a, t, s, f);
      m = Math.max(m, T);
    }
    let u = !1;
    const d = a !== t && a >= 0 && a < s.length;
    if (r && d) {
      const T = s[a];
      for (const A of o.keys()) {
        const k = b.get(A)?.obj.transform;
        if (k && (k === T || k.isDescendantOf(T))) {
          u = !0;
          break;
        }
      }
    }
    let g = 0;
    const w = () => {
      if (p === this._deactivationGeneration && !(--g > 0)) {
        this._cancelDeactivationTimer();
        for (let T = 0; T < s.length; T++) this._setPageActive(s[T], T === this._activeIndex);
      }
    }, y = r && m > 0;
    let P = !1;
    if (r && d && !i) {
      const T = this.sceneObject.traceScene.findSceneObjectByTransform(s[a]), A = T ? this._playPageExitClip(T) : void 0;
      A && (P = !0, g++, A.then(w));
    }
    if (r && d && !u && !P && this._setPageActive(s[a], !1), y && (g++, this._deactivationTimer = J(this.scene).after(m * 1e3, () => {
      this._deactivationTimer = null, w();
    })), !y && !P) for (let T = 0; T < s.length; T++) this._setPageActive(s[T], T === t);
  }
  reapplyPageStates(t = {}) {
    if (!this._pageStatesApplied || this.isShowingAll()) return;
    const s = this._pageStateMap(this._resolved.pages ?? [], this._activeIndex), n = this._resolveTargets(s.keys());
    if (t.scope)
      for (const [r, i] of n) t.scope.has(i.obj) || n.delete(r);
    for (const { props: r, state: i } of this._fanAssignments(s, n)) r.setState(i, !0);
  }
  _applyShowingPageStates() {
    if (!this.attachedNode || !this.playMode || this.isShowingAll()) return;
    const t = this._resolved.pages ?? [], s = this._pageStateMap(t, this._activeIndex), n = this._resolveTargets(this._allMappedPaths(t)), r = /* @__PURE__ */ new Set();
    for (const { member: i, props: a, state: o } of this._fanAssignments(s, n))
      r.add(i), a.setState(o, !0);
    for (const i of this._fanReverts(s, n, r)) i.setState(void 0, !0);
    this._pageStatesApplied = !0;
  }
  _allMappedPaths(t) {
    const s = /* @__PURE__ */ new Set();
    for (const n of t) for (const r of n?.states ?? []) s.add(r.target);
    return s;
  }
  *_fanReverts(t, s, n) {
    for (const [r, i] of s)
      if (!t.has(r))
        for (const a of le(i.obj, void 0)) {
          if (n.has(a)) continue;
          const o = a === i.obj ? i.props : a.getBehavior(V);
          o && (yield o);
        }
  }
  _pageStateMap(t, s) {
    const n = /* @__PURE__ */ new Map();
    for (const r of t[s]?.states ?? []) n.set(r.target, r.state);
    return n;
  }
  _resolveTargets(t) {
    const s = /* @__PURE__ */ new Map();
    for (const n of t) {
      const r = this.sceneObject.traceScene.resolveSceneObject(n, this.sceneObject), i = r?.getBehavior(V);
      r && i && s.set(n, {
        obj: r,
        props: i
      });
    }
    return s;
  }
  *_fanAssignments(t, s) {
    for (const [n, r] of t) {
      const i = s.get(n);
      if (i)
        for (const a of le(i.obj, r)) {
          const o = a === i.obj ? i.props : a.getBehavior(V);
          o && (yield {
            member: a,
            props: o,
            state: r
          });
        }
    }
  }
  _snapEnterState(t) {
    if (t.hasState("_pageEnter"))
      return t.setState(ye, !0), ye;
  }
  _playPageExitClip(t) {
    return this._getExitSequence(t)?.requestExit();
  }
  _getExitSequence(t) {
    const s = t.getBehavior("AnimationSequence");
    return !s || typeof s.requestExit != "function" || s.getExit?.()?.isEmpty !== !1 ? null : s;
  }
  _processPagePropertyCrossfade(t, s, n, r) {
    const i = this.sceneObject.traceScene, a = n[t], o = n[s];
    if (!a || !o) return 0;
    const c = i.findSceneObjectByTransform(a), l = i.findSceneObjectByTransform(o);
    if (!c || !l) return 0;
    const h = c.getBehavior(V), v = l.getBehavior(V);
    if (!h || !v) return 0;
    const p = /* @__PURE__ */ new Map();
    for (const u of v.getPropertyNames()) {
      const d = h.getValue(u), g = v.getValue(u);
      d !== void 0 && g !== void 0 && d !== g && p.set(u, {
        from: d,
        to: g
      });
    }
    if (p.size === 0) return 0;
    this._pagePropertyCleanup?.();
    const b = [...p.keys()];
    for (const [u, { from: d }] of p) v._setTransitionValue(u, d);
    this._pagePropertyCleanup = () => {
      for (const u of b) v._clearTransitionValue(u);
    };
    const m = r.duration + (r.delay ?? 0);
    if (m <= 0)
      return this._pagePropertyCleanup(), this._pagePropertyCleanup = null, 0;
    const E = J(this.sceneObject.babylonScene), f = `pageProps:${this.sceneObject.transform.uniqueId}`;
    return E.start(f, r, (u) => {
      for (const [d, { from: g, to: w }] of p) u === 1 ? v._clearTransitionValue(d) : v._setTransitionValue(d, It(g, w, u));
    }, () => {
      for (const u of b) v._clearTransitionValue(u);
      this._pagePropertyCleanup = null;
    }), m;
  }
  _hasBoundActive(t) {
    return typeof this.sceneObject.traceScene.findSceneObjectByTransform(t)?.getSceneObjectData().active == "string";
  }
  _setPageActive(t, s) {
    const n = this.sceneObject.traceScene.findSceneObjectByTransform(t);
    n ? n.setActive(s) : t.setEnabled(s);
  }
  _startAutoplay() {
    if (!this._resolved.autoplay && !this._playing) return;
    this._stopAutoplay();
    const t = (this._resolved.pageDuration ?? 5) * 1e3;
    S.debug(`[Pages] Starting autoplay on ${this.sceneObject.name} (${t}ms per page, loop=${this._resolved.loop ?? !1})`), this._scheduleNext(t);
  }
  _stopAutoplay() {
    this._autoplayTimer !== null && (this._autoplayTimer(), this._autoplayTimer = null, S.debug(`[Pages] Stopped autoplay on ${this.sceneObject.name}`));
  }
  _scheduleNext(t) {
    this._autoplayTimer = J(this.scene).after(t, () => this._autoplayTick(t));
  }
  _autoplayTick(t) {
    if (this._autoplayTimer = null, this._pendingSwap !== null) {
      this.showPage(this._pendingSwap.targetIndex, !0);
      return;
    }
    const s = this.getPageNodes();
    if (s.length < 2) return;
    let n = this._activeIndex + 1;
    if (n >= s.length) if (this._resolved.loop) n = 0;
    else {
      S.debug(`[Pages] Autoplay finished on ${this.sceneObject.name} (last page, no loop)`), this._playing = !1;
      return;
    }
    n !== this._activeIndex && this.showPage(n, !0);
  }
}, Ns = "Render Bounds", Se = 0.01, Ze = 1e3, Vs = 75e-5, Rs = 0.5, ae = /* @__PURE__ */ new WeakMap(), te = /* @__PURE__ */ new WeakMap();
function Te(e, t, s) {
  const n = te.get(e);
  n && (clearTimeout(n.timer), Object.assign(e, n.saved), te.delete(e));
  const r = {};
  t.framingTime !== void 0 && (r.framingTime = e.framingTime, e.framingTime = t.framingTime), t.radiusScale !== void 0 && (r.radiusScale = e.radiusScale, e.radiusScale = t.radiusScale);
  const i = setTimeout(() => {
    Object.assign(e, r), te.delete(e);
  }, s);
  te.set(e, {
    timer: i,
    saved: r
  });
}
var Ae = /* @__PURE__ */ new WeakMap();
function Fs(e) {
  const t = Ae.get(e);
  if (!t || t.x === 0 && t.y === 0) return;
  const s = e.getProjectionMatrix();
  for (let n = 0; n < 4; n++) {
    const r = s.m[n * 4 + 3];
    r !== 0 && (s.addAtIndex(n * 4, t.x * r), s.addAtIndex(n * 4 + 1, t.y * r));
  }
}
function lt(e, t, s) {
  const n = Ae.has(e);
  !n && t === 0 && s === 0 || (Ae.set(e, {
    x: t,
    y: s
  }), n || e.onProjectionMatrixChangedObservable.add(() => Fs(e)), e.getProjectionMatrix(!0));
}
function ut(e, t) {
  const s = {
    width: 1,
    height: 1,
    x: 0,
    y: 0
  };
  if (!t) return s;
  const n = e.getScene().getEngine(), r = n.getRenderingCanvasClientRect(), i = r?.width || n.getRenderWidth(), a = r?.height || n.getRenderHeight(), o = Math.max(0, t.left), c = Math.max(0, t.right), l = Math.max(0, t.top), h = Math.max(0, t.bottom), v = i - o - c, p = a - l - h;
  return !i || !a || v <= 0 || p <= 0 ? s : {
    width: v / i,
    height: p / a,
    x: (o - c) / i,
    y: (h - l) / a
  };
}
function ht(e, t, s, n, r) {
  const i = e.getEngine().getAspectRatio(e), a = Math.tan(e.fov / 2), o = (e.fovMode === xe.FOVMODE_HORIZONTAL_FIXED ? a : a * i) * r.width, c = (e.fovMode === xe.FOVMODE_HORIZONTAL_FIXED ? a / i : a) * r.height, l = t.add(s).scaleInPlace(0.5);
  l.y = t.y + (s.y - t.y) * n.positionScale;
  const h = e.getViewMatrix(), v = e.getScene().useRightHandedSystem ? 1 : -1, p = ae.get(e) ?? e.minZ;
  let b = p;
  for (const E of [t.x, s.x]) for (const f of [t.y, s.y]) for (const u of [t.z, s.z]) {
    const d = O.TransformNormal(new O(E, f, u).subtractInPlace(l), h), g = d.z * v;
    b = Math.max(b, g + p, g + n.radiusScale * Math.max(Math.abs(d.x) / o, Math.abs(d.y) / c));
  }
  const m = b * (1 + 2 ** -23);
  return Number.isFinite(m) ? m : null;
}
function se(e, t, s, n, r) {
  const i = ut(e, r);
  lt(e, i.x, i.y);
  const a = t.radiusScale, o = e._calculateLowerRadiusFromModelBoundingSphere(s, n), c = o > 0 ? ht(e, s, n, t, i) : null;
  c !== null && (t.radiusScale = c / o);
  try {
    t.zoomOnBoundingInfo(s, n);
  } finally {
    t.radiusScale = a;
  }
}
var Ds = class extends Ut {
  _integratedFrameId = -1;
  _reenteredFrameId = -1;
  computeCurrentFrameDeltas() {
    const e = this._scene.getFrameId();
    if (e === this._integratedFrameId) {
      this._reenteredFrameId = e;
      return;
    }
    this._integratedFrameId = e, super.computeCurrentFrameDeltas();
  }
  resetPanVelocity() {
    if (this._reenteredFrameId === this._scene.getFrameId()) {
      this._reenteredFrameId = -1;
      return;
    }
    super.resetPanVelocity();
  }
}, ri = class dt {
  static setupCamera(t) {
    t.useRightHandedSystem = !0;
    const s = new xe("Camera2", Math.PI / 2, Math.PI / 2, 3, new O(0, 0, 0), t);
    s.movement = new Ds(t, s.position), s.movement.panInertia = s.panningInertia, s.overrideCloneAlphaBetaRadius = !0, s.lowerRadiusLimit = 0.01, s.upperRadiusLimit = 50, s.minZ = Se, s.maxZ = Ze, ae.set(s, Se), s.onViewMatrixChangedObservable.add(() => dt.syncNearPlane(s)), s.wheelPrecision = 0.25, s.wheelDeltaPercentage = 0.015, s.inertia = 0.9, s.useFramingBehavior = !0;
    const n = s.getBehaviorByName("Framing");
    return n && (n.framingTime = 0, n.mode = zt.FitFrustumSidesMode, n.elevationReturnTime = -1), s;
  }
  static estimateParticleSystemBounds(t) {
    if (!t.particleSystems || t.particleSystems.length === 0) return null;
    const s = new O(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), n = new O(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    let r = !1;
    for (const i of t.particleSystems) {
      let a = O.Zero();
      i.emitter && (i.emitter instanceof $e ? a = i.emitter.getAbsolutePosition() : i.emitter instanceof Le && (a = i.emitter.position));
      let o = 1;
      if (i.particleEmitterType) {
        const h = i.particleEmitterType;
        h.radius !== void 0 && (o = Math.max(o, h.radius)), h.radiusRange !== void 0 && (o = Math.max(o, h.radiusRange));
      }
      const c = Math.max(Math.abs(i.minEmitPower || 0), Math.abs(i.maxEmitPower || 0)) * 0.75, l = o + c;
      s.x = Math.min(s.x, a.x - l), s.y = Math.min(s.y, a.y - l), s.z = Math.min(s.z, a.z - l), n.x = Math.max(n.x, a.x + l), n.y = Math.max(n.y, a.y + l), n.z = Math.max(n.z, a.z + l), r = !0;
    }
    return r ? {
      min: s,
      max: n
    } : null;
  }
  static isFramableMesh(t) {
    return !t.isVisible || t.visibility <= 0 || !t.isEnabled() || t.name.endsWith("__collider") || t.name.endsWith("__selection") ? !1 : t.name === "__anchor_preview__" || t.name.startsWith("__builtin_") ? !0 : !t.name.startsWith("__");
  }
  static expandByMeshBounds(t, s, n) {
    if (t.computeWorldMatrix(!0), !t.subMeshes || t.subMeshes.length === 0 || t.infiniteDistance) return !1;
    const i = t.getBoundingInfo(), a = i.boundingBox.minimumWorld, o = i.boundingBox.maximumWorld;
    return !isFinite(a.x + a.y + a.z + o.x + o.y + o.z) || Math.abs(a.x) > 1e30 || Math.abs(a.y) > 1e30 || Math.abs(a.z) > 1e30 || Math.abs(o.x) > 1e30 || Math.abs(o.y) > 1e30 || Math.abs(o.z) > 1e30 || a.equals(o) ? !1 : (a.x < s.x && (s.x = a.x), a.y < s.y && (s.y = a.y), a.z < s.z && (s.z = a.z), o.x > n.x && (n.x = o.x), o.y > n.y && (n.y = o.y), o.z > n.z && (n.z = o.z), !0);
  }
  static getNodeBounds(t) {
    t.getScene().incrementRenderId(), t.computeWorldMatrix(!0);
    const s = t.getChildMeshes(!1);
    t instanceof $e && s.push(t);
    const n = new O(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), r = new O(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    let i = !1;
    for (const a of s)
      this.isFramableMesh(a) && (i = this.expandByMeshBounds(a, n, r) || i);
    return i && !n.equals(r) ? {
      min: n,
      max: r
    } : null;
  }
  static getSceneBounds(t) {
    let s = new O(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), n = new O(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    for (const r of t.meshes)
      this.isFramableMesh(r) && this.expandByMeshBounds(r, s, n);
    if (s.equals(new O(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE)) || n.equals(new O(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE)) || s.equals(n)) {
      S.log("No valid mesh bounds found, attempting to estimate from particle systems");
      const r = this.estimateParticleSystemBounds(t);
      r ? (s = r.min, n = r.max, S.log(`Using particle system bounds: ${s.toString()} to ${n.toString()}`)) : (S.log("No particle systems found, using default 3-unit cube"), s = new O(-1.5, -1.5, -1.5), n = new O(1.5, 1.5, 1.5));
    }
    return {
      min: s,
      max: n
    };
  }
  static applyClipPlanes(t, s) {
    ae.set(t, Math.max(Math.min(Se, s * 0.05), 1e-4)), t.maxZ = Math.max(Ze, s * 10), this.syncNearPlane(t);
  }
  static syncNearPlane(t) {
    const s = ae.get(t) ?? 0.01, n = t.radius, r = n * n / (Vs * 2 ** 24), i = Math.max(s, Math.min(r, Rs));
    Math.abs(i - t.minZ) > t.minZ * 0.02 && (t.minZ = i);
  }
  static calculateSceneBoundingBox(t, s, n, r) {
    const { min: i, max: a } = this.getSceneBounds(t), o = s.getBehaviorByName("Framing");
    if (o) {
      const c = s.alpha, l = s.beta;
      n.cameraRadius !== 1 && (o.radiusScale = n.cameraRadius), s.lowerRadiusLimit = 0, s.upperRadiusLimit = 1 / 0, se(s, o, i, a, r), s.alpha = c, s.beta = l, s.lowerRadiusLimit = s.radius * 0.05, s.upperRadiusLimit = s.radius * 5, this.applyClipPlanes(s, s.radius), S.log(`Camera framed at radius ${s.radius.toFixed(3)} for bounds ${a.subtract(i).length().toFixed(3)}`);
    }
    if (n.mode) {
      const c = a.subtract(i).length(), l = new Le(Ns), h = je("maxSphere", { diameter: c * 0.05 }, t), v = je("minSphere", { diameter: c * 0.05 }, t);
      h.parent = l, v.parent = l, v.position = i, h.position = a, l.setEnabled(!1);
    }
  }
  static resetCamera(t, s, n = !0, r) {
    const { min: i, max: a } = this.getSceneBounds(t), o = s.getBehaviorByName("Framing");
    if (o)
      Te(o, { framingTime: n ? 500 : 0 }, n ? 600 : 100), se(s, o, i, a, r);
    else {
      const c = ut(s, r);
      lt(s, c.x, c.y);
      const l = i.add(a).scale(0.5);
      s.setTarget(l);
      const h = ht(s, i, a, {
        positionScale: 0.5,
        radiusScale: 1.5
      }, c) ?? a.subtract(i).length() * 1.5 / Math.min(c.width, c.height);
      s.radius = h, S.log(`Camera reset to center: ${l.toString()}, radius: ${h.toFixed(3)}`);
    }
  }
  static focusOnNode(t, s, n, r) {
    const i = t.getBehaviorByName("Framing");
    if (!i)
      return S.log("Cannot focus node - camera has no FramingBehavior"), !1;
    const a = n?.radiusScale ?? 1.5, o = n?.framingTime ?? 300;
    let c = this.getNodeBounds(s);
    if (!c) {
      const l = s.getAbsolutePosition(), h = new O(0.5, 0.5, 0.5);
      c = {
        min: l.subtract(h),
        max: l.add(h)
      };
    }
    return Te(i, {
      framingTime: o,
      radiusScale: a
    }, o + 100), se(t, i, c.min, c.max, r), !0;
  }
  static focusOnNodes(t, s, n, r) {
    if (s.length <= 1) return s.length === 1 ? this.focusOnNode(t, s[0], n, r) : !1;
    const i = t.getBehaviorByName("Framing");
    if (!i)
      return S.log("Cannot focus nodes - camera has no FramingBehavior"), !1;
    const a = n?.radiusScale ?? 1.5, o = n?.framingTime ?? 300, c = new O(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), l = new O(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE), h = s.map((p) => ({
      node: p,
      bounds: this.getNodeBounds(p)
    })), v = h.filter(({ bounds: p }) => p !== null).map(({ node: p }) => p);
    for (const { node: p, bounds: b } of h) {
      let m = b;
      if (!m) {
        if (v.some((u) => p.isDescendantOf(u))) continue;
        const E = p.getAbsolutePosition(), f = new O(0.5, 0.5, 0.5);
        m = {
          min: E.subtract(f),
          max: E.add(f)
        };
      }
      m.min.x < c.x && (c.x = m.min.x), m.min.y < c.y && (c.y = m.min.y), m.min.z < c.z && (c.z = m.min.z), m.max.x > l.x && (l.x = m.max.x), m.max.y > l.y && (l.y = m.max.y), m.max.z > l.z && (l.z = m.max.z);
    }
    return Te(i, {
      framingTime: o,
      radiusScale: a
    }, o + 100), se(t, i, c, l, r), !0;
  }
}, Gs = Object.freeze({}), $s = class {
  _object = null;
  _revision = NaN;
  _reported = !1;
  constructor(e, t, s) {
    this._path = e, this._host = t, this._traceScene = s;
  }
  get object() {
    if (!this._path) return this._host;
    const e = this._traceScene.structureRevision, t = typeof e == "number" ? e : NaN;
    return t === this._revision && !this._object?.transform.isDisposed() ? this._object : (this._revision = t, this._object = this._traceScene.resolveSceneObject(this._path, this._host), !this._object && !this._reported && (this._reported = !0, S.error(`[GraphCompiler] Event target path "${this._path}" could not be resolved — the trigger does nothing until an object is there`)), this._object);
  }
  get mesh() {
    return this.object?.transform ?? Gs;
  }
  follow(e) {
    this._path && (e.dataTransformer = () => this.mesh);
  }
}, pt = "__traceScene", ft = "__contextObject";
function Ve(e, t, s) {
  e._setGlobalContextVariable(pt, t), e._setGlobalContextVariable(ft, s);
}
function C(e, t) {
  const s = e._getGlobalContextVariable(pt, null), n = e._getGlobalContextVariable(ft, null);
  if (!t) return n;
  const r = s?.resolveSceneObject(t, n ?? void 0) ?? null;
  return r || S.error(`[resolveTarget] Target path "${t}" could not be resolved — doing nothing`), r;
}
var Ls = class extends B {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("value", F);
  }
  _updateOutputs(e) {
    const t = C(e, this._targetPath);
    this.getDataOutput("value").setValue(t?.active ?? !1, e);
  }
  getClassName() {
    return "TraceGetActiveBlock";
  }
}, ii = class {
  _enabled = !0;
  _pendingEnabled = null;
  get enabled() {
    return this._enabled;
  }
  set(e, t) {
    return t || (this._pendingEnabled = e), this._enabled === e ? !1 : (this._enabled = e, !0);
  }
  reset(e) {
    this._enabled = this._pendingEnabled ?? e, this._pendingEnabled = null;
  }
  clearPending() {
    this._pendingEnabled = null;
  }
};
function js(e) {
  return e !== null && typeof e == "object" && typeof e.setRuntimeEnabled == "function" && typeof e.isRuntimeEnabled == "function";
}
var Us = class extends I {
  _targetPath;
  _behaviorType;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._behaviorType = e?.behavior ?? "", this.registerDataInput("enabled", F, !0);
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (s && this._behaviorType) {
      const n = s.getBehavior(this._behaviorType);
      if (n && js(n)) {
        const r = this.getDataInput("enabled").getValue(e);
        n.setRuntimeEnabled(r);
      } else S.warn(`[TraceSetBehaviorEnabledBlock] "${s.name}" has no toggleable "${this._behaviorType}" behavior`);
    }
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceSetBehaviorEnabledBlock";
  }
}, zs = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("state", F);
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (s) {
      const n = this.getDataInput("state").getValue(e);
      s.setActive(n);
    }
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceSetActiveBlock";
  }
}, Hs = class extends Ie {
  _targetPath;
  _clip;
  _generation = 0;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._clip = e?.clip, this.registerDataInput("speed", M, 1), this.registerDataInput("loop", F, !1);
  }
  _execute(e, t) {
    const s = this.getDataInput("speed").getValue(e), n = this.getDataInput("loop").getValue(e), r = C(e, this._targetPath);
    if (!r) {
      this.out._activateSignal(e);
      return;
    }
    const i = r.getBehavior(et);
    i ? this._executeViaBehavior(e, i, s, n) : this._executeDirectly(e, r, s, n);
  }
  _executeViaBehavior(e, t, s, n) {
    const r = ++this._generation, i = t.play({
      clip: this._clip,
      speed: s,
      loop: n
    });
    this.out._activateSignal(e), n || i.then(() => {
      this._generation === r && this.done._activateSignal(e);
    });
  }
  _executeDirectly(e, t, s, n) {
    this._removePendingObserver(e);
    const r = this._resolveAnimationGroup(t.animationClips);
    if (!r) {
      S.warn(`[TracePlayAnimationBlock] No animation "${this._clip ?? "(default)"}" on ${t.name}`), this.out._activateSignal(e);
      return;
    }
    const i = ++this._generation;
    if (r.isPlaying && r.stop(), r.start(n, s), this.out._activateSignal(e), !n) {
      const a = r.onAnimationGroupEndObservable.addOnce(() => {
        this._generation === i && this.done._activateSignal(e);
      });
      e._setExecutionVariable(this, "_pendingObserver", a), e._setExecutionVariable(this, "_pendingGroup", r);
    }
  }
  _removePendingObserver(e) {
    const t = e._getExecutionVariable(this, "_pendingObserver", null), s = e._getExecutionVariable(this, "_pendingGroup", null);
    t && s && s.onAnimationGroupEndObservable.remove(t), e._deleteExecutionVariable(this, "_pendingObserver"), e._deleteExecutionVariable(this, "_pendingGroup");
  }
  _resolveAnimationGroup(e) {
    return this._clip ? e.get(this._clip) ?? null : e.values().next().value ?? null;
  }
  _preparePendingTasks(e) {
  }
  _cancelPendingTasks(e) {
    this._generation++, this._removePendingObserver(e);
  }
  getClassName() {
    return "TracePlayAnimationBlock";
  }
}, Ws = class extends Ie {
  _targetPath;
  _src;
  _clip;
  _generation = 0;
  started;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._src = e?.src ?? "", this._clip = e?.clip, this.registerDataInput("speed", M, 1), this.registerDataInput("loop", F, !1), this.started = this._registerSignalOutput("started");
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    const n = s.getBehavior(et);
    if (!n) {
      S.warn(`[TracePlayExternalBlock] No Animation behavior on ${s.name}`), this.out._activateSignal(e);
      return;
    }
    if (!this._src) {
      S.warn("[TracePlayExternalBlock] No src specified"), this.out._activateSignal(e);
      return;
    }
    const r = this.getDataInput("speed").getValue(e), i = this.getDataInput("loop").getValue(e), a = ++this._generation, o = n.playExternal(this._src, {
      clip: this._clip,
      speed: r,
      loop: i,
      onStarted: () => {
        this._generation === a && this.started._activateSignal(e);
      }
    });
    this.out._activateSignal(e), o.then(() => {
      !i && this._generation === a && this.done._activateSignal(e);
    }).catch((c) => {
      S.warn(`[TracePlayExternalBlock] playExternal("${this._src}") failed: ${String(c)}`);
    });
  }
  _preparePendingTasks(e) {
  }
  _cancelPendingTasks(e) {
    this._generation++;
  }
  getClassName() {
    return "TracePlayExternalBlock";
  }
}, Xs = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("play", F, void 0), this.registerDataInput("volume", M, -1), this.registerDataInput("seek", M, -1);
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    const n = s.getBehavior(Cs);
    if (!n) {
      S.warn(`[TracePlayVideoBlock] No Video behavior on ${s.name}`), this.out._activateSignal(e);
      return;
    }
    const r = this.getDataInput("volume").getValue(e);
    r >= 0 && n.setVolume(r);
    const i = this.getDataInput("seek").getValue(e);
    i >= 0 && n.seek(i);
    const a = this.getDataInput("play").getValue(e);
    a === !0 ? n.play() : a === !1 && n.pause(), this.out._activateSignal(e);
  }
  getClassName() {
    return "TracePlayVideoBlock";
  }
};
function U(e, t) {
  const s = C(e, t);
  if (!s) return null;
  const n = qs(s);
  return n ? {
    target: s,
    playable: n
  } : null;
}
function qs(e) {
  let t = null;
  for (const s of e.getBehaviors())
    if (Dt(s)) {
      if (st(s)) return s;
      t || (t = s);
    }
  return t;
}
var Ks = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("src", W, ""), this.registerDataInput("volume", M, -1), this.registerDataInput("seek", M, -1);
  }
  _execute(e, t) {
    const s = U(e, this._targetPath);
    if (!s) {
      S.warn(`[TracePlayMediaBlock] No Playable behavior on target "${this._targetPath}"`), this.out._activateSignal(e);
      return;
    }
    const { playable: n } = s, r = this.getDataInput("src").getValue(e), i = this.getDataInput("volume").getValue(e), a = this.getDataInput("seek").getValue(e), o = () => {
      i >= 0 && tt(n) && n.setVolume(i), a >= 0 && n.seek(a), n.play();
    };
    if (r && st(n)) {
      const c = n.setSource(r);
      c && typeof c.then == "function" ? c.then(o).catch((l) => {
        const h = l instanceof Error ? l.message : String(l);
        S.warn(`[TracePlayMediaBlock] setSource failed for "${this._targetPath}": ${h}`);
      }) : o();
    } else o();
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TracePlayMediaBlock";
  }
}, Qs = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "";
  }
  _execute(e, t) {
    const s = U(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    s.playable.pause(), this.out._activateSignal(e);
  }
  getClassName() {
    return "TracePauseMediaBlock";
  }
}, Zs = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "";
  }
  _execute(e, t) {
    const s = U(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    s.playable.stop(), this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceStopMediaBlock";
  }
}, Ys = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("time", M, 0);
  }
  _execute(e, t) {
    const s = U(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    const n = this.getDataInput("time").getValue(e);
    s.playable.seek(n), this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceSeekMediaBlock";
  }
}, Js = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("volume", M, 1);
  }
  _execute(e, t) {
    const s = U(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    if (tt(s.playable)) {
      const n = this.getDataInput("volume").getValue(e);
      s.playable.setVolume(n);
    }
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceSetMediaVolumeBlock";
  }
}, en = class extends B {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("value", F);
  }
  _updateOutputs(e) {
    const t = U(e, this._targetPath)?.playable, s = !!t && Rt(t) && t.isPlaying();
    this.getDataOutput("value").setValue(s, e);
  }
  getClassName() {
    return "TraceIsMediaPlayingBlock";
  }
}, tn = class extends B {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("value", M);
  }
  _updateOutputs(e) {
    const t = U(e, this._targetPath)?.playable, s = t && Ft(t) ? t.getVolume() : 1;
    this.getDataOutput("value").setValue(s, e);
  }
  getClassName() {
    return "TraceGetMediaVolumeBlock";
  }
}, sn = class extends I {
  constructor(e) {
    super(e), this.registerDataInput("url", W, "");
  }
  _execute(e, t) {
    const s = this.getDataInput("url").getValue(e);
    s && window.open(s, "_blank", "noopener,noreferrer"), this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceNavigateBlock";
  }
}, nn = class extends B {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("value", M);
  }
  _updateOutputs(e) {
    const t = C(e, this._targetPath);
    this.getDataOutput("value").setValue(t?.getChildren().length ?? 0, e);
  }
  getClassName() {
    return "TraceGetChildCountBlock";
  }
}, rn = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("index", M, 0);
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    const n = s.getChildren();
    if (n.length === 0) {
      S.warn(`[TraceSetActiveChildBlock] No children on ${s.name}`), this.out._activateSignal(e);
      return;
    }
    const r = this.getDataInput("index").getValue(e), i = Math.max(0, Math.min(Math.floor(r), n.length - 1));
    for (let a = 0; a < n.length; a++) n[a].setActive(a === i);
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceSetActiveChildBlock";
  }
}, an = class extends B {
  _targetPath;
  _propertyName;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._propertyName = e?.property ?? "", this.registerDataOutput("value", R);
  }
  _updateOutputs(e) {
    const t = C(e, this._targetPath), s = t?.resolveProperty(this._propertyName);
    s == null && S.warn(`[TraceGetPropertyBlock] Property "${this._propertyName}" not resolved on "${t?.name ?? this._targetPath}"`);
    let n = s;
    Array.isArray(s) && s.length === 3 && (n = O.FromArray(s)), this.getDataOutput("value").setValue(n ?? void 0, e);
  }
  getClassName() {
    return "TraceGetPropertyBlock";
  }
}, on = class extends I {
  _targetPath;
  _propertyName;
  _transition;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._propertyName = e?.property ?? "", this._transition = e?.transition, this.registerDataInput("value", R);
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (s) {
      const n = s.getBehavior("Properties");
      if (n) {
        let r = this.getDataInput("value").getValue(e);
        if ((r instanceof O || r instanceof H) && (r = r.asArray()), n.getProperty(this._propertyName)?.type === "color" && Array.isArray(r) && r.length >= 3) {
          const i = (a) => Math.round(Math.max(0, Math.min(1, a)) * 255).toString(16).padStart(2, "0");
          r = `#${i(r[0])}${i(r[1])}${i(r[2])}`;
        }
        n.setValue(this._propertyName, r, this._transition) || S.warn(`[TraceSetPropertyBlock] Property "${this._propertyName}" not found or type mismatch on "${s.name}"`);
      } else S.warn(`[TraceSetPropertyBlock] Target "${s.name}" has no Properties behavior`);
    }
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceSetPropertyBlock";
  }
}, cn = class extends B {
  constructor(e) {
    super(e), this.registerDataOutput("elapsed", M);
  }
  _updateOutputs(e) {
    const t = e._getGlobalContextVariable("__traceScene", null)?.getSystemValues().getElapsed() ?? 0;
    this.getDataOutput("elapsed").setValue(t, e);
  }
  getClassName() {
    return "TraceTimeBlock";
  }
}, ln = class extends I {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("state", W, "");
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (s) {
      const n = this.getDataInput("state").getValue(e), r = n === "" ? void 0 : n, i = le(s, r);
      for (const a of i) {
        const o = a.getBehavior(V);
        o ? o.setState(r) : a === s && S.warn(`[TraceSetStateBlock] Target "${s.name}" has no Properties behavior`);
      }
    }
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceSetStateBlock";
  }
}, un = class extends B {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("state", W);
  }
  _updateOutputs(e) {
    const t = C(e, this._targetPath)?.getBehavior(V)?.getActiveState() ?? "";
    this.getDataOutput("state").setValue(t, e);
  }
  getClassName() {
    return "TraceGetStateBlock";
  }
}, hn = class extends he {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("prevState", W), this.registerDataOutput("newState", W);
  }
  _preparePendingTasks(e) {
    if (e._getExecutionVariable(this, "_observer", null)) return;
    const t = C(e, this._targetPath);
    if (!t) return;
    const s = t.getBehavior(V);
    if (!s) return;
    let n = !1;
    const r = s.onStateChangedObservable.add(({ prev: i, next: a }) => {
      n || (this.getDataOutput("prevState").setValue(i ?? "", e), this.getDataOutput("newState").setValue(a ?? "", e), this.out._activateSignal(e));
    });
    e._setExecutionVariable(this, "_observer", r), e._setExecutionVariable(this, "_props", s), e._setExecutionVariable(this, "_cancel", { cancel: () => {
      n = !0;
    } });
  }
  _cancelPendingTasks(e) {
    e._getExecutionVariable(this, "_cancel", null)?.cancel();
    const t = e._getExecutionVariable(this, "_props", null), s = e._getExecutionVariable(this, "_observer", null);
    t && s && t.onStateChangedObservable.remove(s), e._deleteExecutionVariable(this, "_observer"), e._deleteExecutionVariable(this, "_props"), e._deleteExecutionVariable(this, "_cancel");
  }
  _executeEvent(e, t) {
    return !0;
  }
  getClassName() {
    return "TraceOnStateChangeBlock";
  }
}, dn = class extends he {
  _targetPath;
  enter;
  exit;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataInput("threshold", M, 5), this.enter = this._registerSignalOutput("enter"), this.exit = this._registerSignalOutput("exit"), this.registerDataOutput("distance", M);
  }
  _preparePendingTasks(e) {
    const t = C(e, this._targetPath);
    if (!t) return;
    const s = e.getScene();
    let n = !1, r = !1;
    const i = s.onBeforeRenderObservable.add(() => {
      if (r) return;
      const a = s.activeCamera;
      if (!a) return;
      const o = a.globalPosition, c = t.transform.getAbsolutePosition(), l = o.subtract(c).length();
      this.getDataOutput("distance")?.setValue(l, e);
      const h = l <= this.getDataInput("threshold").getValue(e);
      h && !n ? (n = !0, this.enter._activateSignal(e)) : !h && n && (n = !1, this.exit._activateSignal(e));
    });
    e._setExecutionVariable(this, "_observer", i), e._setExecutionVariable(this, "_cancel", { cancel: () => {
      r = !0;
    } });
  }
  _cancelPendingTasks(e) {
    e._getExecutionVariable(this, "_cancel", null)?.cancel();
    const t = e._getExecutionVariable(this, "_observer", null);
    t && e.getScene().onBeforeRenderObservable.remove(t);
  }
  _executeEvent(e, t) {
    return !0;
  }
  getClassName() {
    return "TraceProximityEventBlock";
  }
}, gt = class extends I {
  _targetPath;
  _direction;
  constructor(e, t) {
    super(t), this._direction = e, this._targetPath = t?.target ?? "", this.registerDataInput("wrap", F, !0), this.registerDataInput("animate", F, !1);
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (!s) {
      this.out._activateSignal(e);
      return;
    }
    const n = this.getDataInput("wrap").getValue(e), r = this.getDataInput("animate").getValue(e), i = s.getBehavior(Ne);
    if (i)
      this._direction === 1 ? i.next(n, r) : i.prev(n, r), this.out._activateSignal(e);
    else {
      const a = s.getChildren();
      if (a.length === 0) {
        this.out._activateSignal(e);
        return;
      }
      const o = a.findIndex((l) => l.active);
      let c = (o === -1 ? 0 : o) + this._direction;
      c >= a.length && (c = n ? 0 : a.length - 1), c < 0 && (c = n ? a.length - 1 : 0);
      for (let l = 0; l < a.length; l++) a[l].setActive(l === c);
      this.out._activateSignal(e);
    }
  }
}, pn = class extends gt {
  constructor(e) {
    super(1, e);
  }
  getClassName() {
    return "TracePagesNextBlock";
  }
}, fn = class extends gt {
  constructor(e) {
    super(-1, e);
  }
  getClassName() {
    return "TracePagesPrevBlock";
  }
}, gn = class extends B {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("value", M);
  }
  _updateOutputs(e) {
    const t = C(e, this._targetPath);
    if (!t) {
      this.getDataOutput("value").setValue(0, e);
      return;
    }
    const s = t.getBehavior(Ne);
    if (s) this.getDataOutput("value").setValue(s.getActivePageIndex(), e);
    else {
      const n = t.getChildren().findIndex((r) => r.active);
      this.getDataOutput("value").setValue(n === -1 ? 0 : n, e);
    }
  }
  getClassName() {
    return "TracePagesGetActiveIndexBlock";
  }
}, _n = class extends B {
  _targetPath;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this.registerDataOutput("value", M);
  }
  _updateOutputs(e) {
    const t = C(e, this._targetPath);
    if (!t) {
      this.getDataOutput("value").setValue(0, e);
      return;
    }
    const s = t.getBehavior(Ne);
    s ? this.getDataOutput("value").setValue(s.getPageCount(), e) : this.getDataOutput("value").setValue(t.getChildren().length, e);
  }
  getClassName() {
    return "TracePagesGetPageCountBlock";
  }
}, mn = /* @__PURE__ */ new Set([
  "translation",
  "rotation",
  "scale"
]), vn = class extends I {
  _targetPath;
  _property;
  err;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._property = e?.property ?? "translation", this.registerDataInput("value", R), this.err = this._registerSignalOutput("err");
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (!s) {
      this.err._activateSignal(e);
      return;
    }
    const n = this.getDataInput("value").getValue(e), r = bn(this._property, n);
    if (!r) {
      S.error(mn.has(this._property) ? `[PointerSetBlock] Invalid ${this._property} value on "${s.name}"` : `[PointerSetBlock] Unknown property "${this._property}" on "${s.name}"`), this.err._activateSignal(e);
      return;
    }
    r(s), this.out._activateSignal(e);
  }
  getClassName() {
    return "PointerSetBlock";
  }
};
function bn(e, t) {
  switch (e) {
    case "translation": {
      const s = ue(t);
      return s ? (n) => n.setPosition(s) : null;
    }
    case "rotation": {
      const s = _t(t);
      return s ? (n) => n.setRotation(s) : null;
    }
    case "scale": {
      const s = ue(t);
      return s ? (n) => n.setScale(s) : null;
    }
    default:
      return null;
  }
}
function ue(e) {
  if (e instanceof O) return e;
  if (Array.isArray(e) && e.length >= 3) return new O(e[0], e[1], e[2]);
  if (e != null && typeof e == "object" && "x" in e && "y" in e && "z" in e) {
    const t = e;
    return new O(t.x, t.y, t.z);
  }
  return null;
}
function _t(e) {
  if (e instanceof H) return e;
  if (Array.isArray(e) && e.length >= 4) return new H(e[0], e[1], e[2], e[3]);
  if (e != null && typeof e == "object" && "x" in e && "y" in e && "z" in e && "w" in e) {
    const t = e;
    return new H(t.x, t.y, t.z, t.w);
  }
  return null;
}
var yn = class extends B {
  _targetPath;
  _property;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._property = e?.property ?? "translation", this.registerDataOutput("value", R);
  }
  _updateOutputs(e) {
    const t = C(e, this._targetPath);
    if (!t) {
      this.getDataOutput("value").setValue(void 0, e);
      return;
    }
    const s = t.transform;
    let n;
    switch (this._property) {
      case "translation":
        n = s.position.clone();
        break;
      case "rotation": {
        const r = s.rotationQuaternion;
        if (r) n = r.clone();
        else {
          const i = s.rotation;
          n = H.FromEulerAngles(i.x, i.y, i.z);
        }
        break;
      }
      case "scale":
        n = s.scaling.clone();
        break;
      default:
        S.warn(`[PointerGetBlock] Unknown property "${this._property}" on "${t.name}"`);
    }
    this.getDataOutput("value").setValue(n, e);
  }
  getClassName() {
    return "PointerGetBlock";
  }
}, Sn = class extends Ie {
  _targetPath;
  _property;
  _generation = 0;
  err;
  constructor(e) {
    super(e), this._targetPath = e?.target ?? "", this._property = e?.property ?? "translation", this.registerDataInput("value", R), this.registerDataInput("duration", M, 0), this.registerDataInput("p1", R), this.registerDataInput("p2", R), this.err = this._registerSignalOutput("err");
  }
  _execute(e, t) {
    const s = C(e, this._targetPath);
    if (!s) {
      this.err._activateSignal(e);
      return;
    }
    const n = this.getDataInput("value").getValue(e), r = this.getDataInput("duration").getValue(e), i = typeof r == "number" && Number.isFinite(r) ? r : 0, a = this._resolveWrite(s, n);
    if (!a) {
      this.err._activateSignal(e);
      return;
    }
    const o = ++this._generation;
    if (i <= 0) {
      a(null, void 0), this.out._activateSignal(e), this._generation === o && this.done._activateSignal(e);
      return;
    }
    const [c, l] = this._controlPoint("p1", e, 0), [h, v] = this._controlPoint("p2", e, 2);
    a({
      duration: i,
      easing: `cubic-bezier(${c}, ${l}, ${h}, ${v})`
    }, () => {
      this._generation === o && this.done._activateSignal(e);
    }), this.out._activateSignal(e);
  }
  _resolveWrite(e, t) {
    switch (this._property) {
      case "translation": {
        const s = ue(t);
        return s ? (n, r) => e._startPositionChannel(s, n, r) : (S.error(`[PointerInterpolateBlock] Invalid translation value on "${e.name}"`), null);
      }
      case "rotation": {
        const s = _t(t);
        return s ? (n, r) => e._startRotationChannel(s, n, r) : (S.error(`[PointerInterpolateBlock] Invalid rotation value on "${e.name}"`), null);
      }
      case "scale": {
        const s = ue(t);
        return s ? (n, r) => e._startScaleChannel(s, n, r) : (S.error(`[PointerInterpolateBlock] Invalid scale value on "${e.name}"`), null);
      }
      default:
        return S.error(`[PointerInterpolateBlock] Unknown property "${this._property}" on "${e.name}"`), null;
    }
  }
  _controlPoint(e, t, s) {
    const n = Tn(this.getDataInput(e).getValue(t));
    if (n) return n;
    const r = Bt.easeInOut;
    return [r[s], r[s + 1]];
  }
  _preparePendingTasks(e) {
  }
  _cancelPendingTasks(e) {
    this._generation++;
  }
  getClassName() {
    return "PointerInterpolateBlock";
  }
};
function Tn(e) {
  if (e instanceof rt) return [e.x, e.y];
  if (Array.isArray(e) && e.length >= 2 && typeof e[0] == "number" && typeof e[1] == "number" && Number.isFinite(e[0]) && Number.isFinite(e[1])) return [e[0], e[1]];
  if (e != null && typeof e == "object" && "x" in e && "y" in e) {
    const t = e;
    if (Number.isFinite(t.x) && Number.isFinite(t.y)) return [t.x, t.y];
  }
  return null;
}
var Oe = "__flowgraph_subgraph_exit", mt = class extends Q {
  _interface;
  _innerGraph;
  _initContext;
  _innerContexts = /* @__PURE__ */ new WeakMap();
  _outputFlowSignals = /* @__PURE__ */ new Map();
  _inputDataConnections = /* @__PURE__ */ new Map();
  _outputDataInfo = /* @__PURE__ */ new Map();
  constructor(e) {
    super(e), this._interface = e.subgraphInterface, this._innerGraph = e.innerGraph, this._initContext = e.initContext;
    for (const [t] of this._interface.inputFlowSockets) t !== "in" && this._registerSignalInput(t);
    for (const [t] of this._interface.outputFlowSockets) this._outputFlowSignals.set(t, this._registerSignalOutput(t));
    for (const [t] of this._interface.inputValueSockets) this._inputDataConnections.set(t, this.registerDataInput(t, R));
    for (const [t, s] of this._interface.outputValueSockets) {
      const n = this.registerDataOutput(t, R);
      this._outputDataInfo.set(t, {
        connection: n,
        innerBlock: s.block,
        innerOutputName: s.outputName
      });
    }
  }
  get innerGraph() {
    return this._innerGraph;
  }
  get subgraphInterface() {
    return this._interface;
  }
  _getInnerContext(e) {
    let t = this._innerContexts.get(e);
    return t || (t = this._innerGraph.createContext(), this._initContext && this._initContext(t), this._innerContexts.set(e, t)), t;
  }
  _bridgeInputValues(e, t) {
    for (const [s, n] of this._inputDataConnections) {
      const r = n.getValue(e), i = this._interface.inputValueSockets.get(s);
      if (i) {
        for (const a of i.connections) {
          const o = a.block.getDataInput(a.inputName);
          o && o.setValue(r, t);
        }
        i.variableName && t.setVariable(i.variableName, r);
      }
    }
  }
  _execute(e, t) {
    const s = this._getInnerContext(e);
    s.setVariable(Oe, ""), this._bridgeInputValues(e, s);
    const n = this._interface.inputFlowSockets.get(t.name);
    if (!n) return;
    const r = n.block.getSignalInput(n.signalName);
    r && r._activateSignal(s);
    const i = s.getVariable(Oe);
    if (i) {
      const a = this._outputFlowSignals.get(i);
      a && a._activateSignal(e);
    }
  }
  _updateOutputs(e) {
    const t = this._getInnerContext(e);
    this._bridgeInputValues(e, t);
    for (const [, s] of this._outputDataInfo) {
      const n = s.innerBlock.getDataOutput(s.innerOutputName);
      n && s.connection.setValue(n.getValue(t), e);
    }
  }
  getClassName() {
    return "FlowGraphSubgraphBlock";
  }
}, Pn = class extends Q {
  exitName;
  constructor(e) {
    super({ name: `__sentinel_${e}` }), this.exitName = e;
  }
  _execute(e) {
    e.setVariable(Oe, this.exitName);
  }
  getClassName() {
    return "ExitSentinelBlock";
  }
};
function En(e) {
  const t = [];
  for (const [s, n] of e) {
    const r = new Pn(s), i = n.block.getSignalOutput(n.signalName);
    i && i.connectTo(r.in), t.push(r);
  }
  return t;
}
var Ye = "traceInternalEventSubscriptions", vt = class extends Q {
  out;
  constructor() {
    super(), this.out = this._registerSignalOutput("out");
  }
  _execute(e, t) {
    this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceInternalEventReceiveBlock";
  }
}, bt = class extends I {
  receivers = [];
  constructor(e) {
    super(), this._eventKey = e;
  }
  _execute(e, t) {
    const s = e.configuration.coordinator, n = `__trace_internal_${e.uniqueId}_${this._eventKey}`, r = e._getGlobalContextVariable(Ye, /* @__PURE__ */ new Set());
    if (!r.has(n)) {
      const i = this.receivers;
      s.getCustomEventObservable(n).add(() => {
        for (const a of i) a._execute(e);
      }), r.add(n), e._setGlobalContextVariable(Ye, r);
    }
    s.notifyCustomEvent(n, {}, !0), this.out._activateSignal(e);
  }
  getClassName() {
    return "TraceInternalEventSendBlock";
  }
}, yt = class extends Error {
  constructor(e) {
    super(e.map((t) => `${t.field}: ${t.message}`).join(`
`)), this.diagnostics = e, this.name = "GraphValidationError";
  }
};
function ke(e, t = [e]) {
  const s = [], n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = (c, l, h) => s.push({
    code: c,
    field: l,
    message: h
  }), a = (c, l) => Number.isInteger(c) && c >= 0 && c < l;
  function o(c, l) {
    if (n.has(c)) {
      i("SUBGRAPH_CYCLE", l, "Recursive subgraph execution is unsupported.");
      return;
    }
    if (r.has(c)) return;
    if (!c || !Array.isArray(c.nodes) || !Array.isArray(c.declarations) || !Array.isArray(c.types) || !Array.isArray(c.variables)) {
      i("GRAPH_SHAPE", l, "Expected nodes, declarations, types and variables arrays.");
      return;
    }
    const h = (f) => f !== null && typeof f == "object" && !Array.isArray(f);
    if (c.nodes.some((f) => !h(f) || f.values !== void 0 && (!h(f.values) || Object.values(f.values).some((u) => !h(u))) || f.flows !== void 0 && (!h(f.flows) || Object.values(f.flows).some((u) => !h(u)))) || c.declarations.some((f) => !h(f)) || c.types.some((f) => !h(f)) || c.variables.some((f) => !h(f))) {
      i("GRAPH_SHAPE", l, "Nodes, declarations, types, variables and socket entries must be objects.");
      return;
    }
    n.add(c);
    const v = (f, u, d) => {
      if (!a(f, c.nodes.length)) return !1;
      const g = c.declarations[c.nodes[f].declaration];
      if (!g) return !1;
      const w = g.extensions?.TRACE_subgraph;
      if (w) {
        const P = t[w.graph];
        return Object.hasOwn({
          dataInputs: P?.inputValueSockets,
          dataOutputs: P?.outputValueSockets,
          flowInputs: P?.inputFlowSockets,
          flowOutputs: P?.outputFlowSockets
        }[d] ?? {}, u);
      }
      const y = ne(g.op);
      return !y || y.registration === "macro" ? !1 : d === "flowOutputs" && g.op === _.FLOW_SEQUENCE ? /^(0|[1-9]\d*)$/.test(u) : y[d].some((P) => (typeof P == "string" ? P : P.name) === u);
    };
    function p(f, u, d = !1) {
      const g = c.types[f.type]?.signature;
      if (!a(f.type, c.types.length) || !g) {
        i("LITERAL_TYPE", u, `Invalid type index ${f.type}.`);
        return;
      }
      const w = {
        bool: 1,
        int: 1,
        float: 1,
        string: 1,
        color: 1,
        float2: 2,
        float3: 3,
        float4: 4,
        float2x2: 4,
        float3x3: 9,
        float4x4: 16
      }, y = w[g] > 1 && f.value?.length === 1 && Array.isArray(f.value[0]) ? f.value[0] : f.value;
      Array.isArray(y) && y.length === w[g] && y.every((P) => g === "bool" ? typeof P == "boolean" : g === "string" ? typeof P == "string" || d && P === null : g === "color" ? typeof P == "string" : typeof P == "number" && Number.isFinite(P) && (g !== "int" || Number.isInteger(P))) || i("LITERAL_VALUE", u, `Expected ${g} literal with ${w[g]} typed component(s); expressions are not literal defaults.`);
    }
    for (const [f, u] of c.variables.entries()) p(u, `${l}.variables[${f}]`);
    for (const [f, u] of c.nodes.entries()) {
      const d = `${l}.nodes[${f}]`, g = c.declarations[u.declaration];
      if (!a(u.declaration, c.declarations.length) || !g) {
        i("DECLARATION_INDEX", d, `Invalid declaration index ${u.declaration}.`);
        continue;
      }
      const w = g.extensions?.TRACE_subgraph;
      if (w) w.asset != null ? i("EXTERNAL_SUBGRAPH", d, "External subgraph assets cannot execute in the native compiler.") : a(w.graph, t.length) ? o(t[w.graph], `graphs[${w.graph}]`) : i("SUBGRAPH_INDEX", d, `Invalid graph index ${w.graph}.`);
      else {
        const y = ne(g.op);
        if (!y || y.registration === "macro") {
          i("UNSUPPORTED_OP", d, `Unsupported native operation "${g.op}". Use the block catalog; lower authoring macros before compilation.`);
          continue;
        }
      }
      for (const [y, P] of Object.entries(u.values ?? {})) {
        const T = `${d}.values.${y}`;
        v(f, y, "dataInputs") || i("INPUT_SOCKET", T, `Unknown input "${y}" on ${g.op}.`), "node" in P ? v(P.node, P.socket, "dataOutputs") || i("OUTPUT_SOCKET", T, `Invalid data source ${P.node}.${P.socket}.`) : p(P, T, !g.extensions?.TRACE_subgraph && ne(g.op)?.dataInputs.find((A) => A.name === y)?.type === "string");
      }
      for (const [y, P] of Object.entries(u.flows ?? {}))
        v(f, y, "flowOutputs") || i("FLOW_OUTPUT", `${d}.flows.${y}`, `Unknown flow output "${y}" on ${g.op}.`), v(P.node, P.socket, "flowInputs") || i("FLOW_INPUT", `${d}.flows.${y}`, `Invalid flow target ${P.node}.${P.socket}.`);
      if (g.op === _.VARIABLE_GET || g.op === _.VARIABLE_SET) {
        const y = u.configuration?.variable?.value?.[0] ?? 0;
        (typeof y != "number" || !a(y, c.variables.length)) && i("VARIABLE_INDEX", d, `Invalid variable index ${JSON.stringify(y)}.`);
      }
      if (g.op === _.EVENT_SEND || g.op === _.EVENT_RECEIVE) {
        const y = u.configuration?.event?.value?.[0], P = Array.isArray(c.events) ? c.events : [];
        typeof y != "number" || !a(y, P.length) ? i("EVENT_INDEX", d, `Invalid custom event index ${JSON.stringify(y)}.`) : Object.keys(P[y]?.values ?? {}).length > 0 && i("EVENT_VALUES", d, "Custom events with value sockets are not supported by the native compiler yet.");
      }
    }
    for (const [f, u] of Object.entries(c.inputFlowSockets ?? {})) v(u.node, u.socket, "flowInputs") || i("SUBGRAPH_INTERFACE", `${l}.inputFlowSockets.${f}`, "Invalid internal flow input.");
    for (const [f, u] of Object.entries(c.outputFlowSockets ?? {})) v(u.node, u.socket, "flowOutputs") || i("SUBGRAPH_INTERFACE", `${l}.outputFlowSockets.${f}`, "Invalid internal flow output.");
    for (const [f, u] of Object.entries(c.outputValueSockets ?? {})) v(u.node, u.socket, "dataOutputs") || i("SUBGRAPH_INTERFACE", `${l}.outputValueSockets.${f}`, "Invalid internal data output.");
    const b = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Set();
    function E(f) {
      if (!(!a(f, c.nodes.length) || m.has(f))) {
        if (b.has(f)) {
          i("DATA_CYCLE", `${l}.nodes[${f}]`, "Cyclic data dependency; use a variable to carry state between events.");
          return;
        }
        b.add(f);
        for (const u of Object.values(c.nodes[f].values ?? {})) "node" in u && E(u.node);
        b.delete(f), m.add(f);
      }
    }
    c.nodes.forEach((f, u) => E(u)), n.delete(c), r.add(c);
  }
  return o(e, `graphs[${Math.max(0, t.indexOf(e))}]`), s;
}
function wn(e, t) {
  const s = ke(e, t);
  if (s.length) throw new yt(s);
}
function xn(e, t, s, n, r) {
  wn(e, r);
  const i = new at({ scene: t }), a = i.createGraph(), o = a.createContext();
  Ve(o, s, n);
  const c = r ?? [e], l = {
    blocks: [],
    context: o,
    coordinator: i,
    scene: t,
    traceScene: s,
    contextObject: n,
    allGraphs: c,
    compilingGraphs: /* @__PURE__ */ new Set(),
    invocationCounter: 0,
    compiledSubgraphs: /* @__PURE__ */ new Map(),
    selectTargets: []
  };
  let h = c.indexOf(e);
  h === -1 && (S.warn("[GraphCompiler] mainIndex: graphData not found in allGraphs, falling back to index 0"), h = 0);
  try {
    An(e, h, l, "");
  } catch (p) {
    throw i.dispose(), p;
  }
  for (const p of l.blocks) p instanceof he && a.addEventBlock(p);
  const v = n.transform.getChildMeshes(!1)[0] ?? null;
  return {
    coordinator: i,
    graph: a,
    context: o,
    get selectTargets() {
      const p = /* @__PURE__ */ new Set();
      for (const b of l.selectTargets) {
        const m = b.object;
        m && p.add(m);
      }
      return p;
    },
    fireEvent(p) {
      i.notifyCustomEvent(p, {});
    },
    fireSelect() {
      if (!v) return;
      const p = new Ht();
      p.hit = !0, p.pickedMesh = v;
      const b = new Lt(L.POINTERPICK, new PointerEvent("pointerdown"), p);
      t.onPointerObservable.notifyObservers(b, L.POINTERPICK);
    },
    fireHoverIn() {
      v && t.onMeshUnderPointerUpdatedObservable.notifyObservers({
        mesh: v,
        pointerId: 0
      }, L.POINTERMOVE);
    },
    fireHoverOut() {
      t.onMeshUnderPointerUpdatedObservable.notifyObservers({
        mesh: null,
        pointerId: 0
      }, L.POINTERMOVE);
    },
    dispose() {
      const p = o._getGlobalContextVariable("pendingDelays", []);
      for (const b of p) b?.dispose();
      i.dispose();
    }
  };
}
function St(e, t) {
  return e.compilingGraphs.has(t) ? (S.warn(`[GraphCompiler] Cycle detected: graph ${t} is already being compiled`), !1) : (e.compilingGraphs.add(t), !0);
}
function An(e, t, s, n) {
  if (!St(s, t)) return;
  const { context: r, contextObject: i, traceScene: a, allGraphs: o } = s;
  for (const l of e.variables) r.setVariable(n + l.name, K(l, e.types));
  const c = [];
  for (let l = 0; l < e.nodes.length; l++) {
    const h = e.nodes[l], v = e.declarations[h.declaration];
    if (!v) {
      S.warn(`[GraphCompiler] Node ${l}: invalid declaration index ${h.declaration}`), c.push(s.blocks.length), s.blocks.push(j());
      continue;
    }
    const p = v.extensions?.TRACE_subgraph;
    if (p) {
      p.asset != null && S.warn(`[GraphCompiler] Node ${l}: external subgraph assets not yet supported (asset index ${p.asset})`);
      const m = o[p.graph];
      if (!m) {
        S.warn(`[GraphCompiler] Node ${l}: subgraph references invalid graph index ${p.graph}`), c.push(s.blocks.length), s.blocks.push(j());
        continue;
      }
      const E = Pt(p.graph, m, s);
      if (!E) {
        c.push(s.blocks.length), s.blocks.push(j());
        continue;
      }
      const f = new mt({
        name: v.op,
        subgraphInterface: E.subgraphInterface,
        innerGraph: E.innerGraph,
        initContext: E.initContext
      });
      c.push(s.blocks.length), s.blocks.push(f);
      continue;
    }
    const b = Et(v.op, h, e, i, a, s.selectTargets, n);
    if (!b) {
      S.warn(`[GraphCompiler] Node ${l}: unknown op "${v.op}"`), c.push(s.blocks.length), s.blocks.push(j());
      continue;
    }
    c.push(s.blocks.length), xt(v.op, b), s.blocks.push(b);
  }
  Tt(e, s.blocks, c);
  for (let l = 0; l < e.nodes.length; l++) {
    const h = e.nodes[l];
    if (!h.values) continue;
    const v = e.declarations[h.declaration], p = v?.op ?? "", b = !!v?.extensions?.TRACE_subgraph;
    for (const [m, E] of Object.entries(h.values)) {
      if (!("node" in E)) {
        const G = s.blocks[c[l]], $ = b ? m : X(p, m), Y = G.getDataInput($);
        if (Y) {
          const q = K(E, e.types);
          Y.setValue(q, r);
        }
        continue;
      }
      const f = E.node, u = e.declarations[e.nodes[f].declaration], d = !!u?.extensions?.TRACE_subgraph, g = u?.op ?? "", w = s.blocks[c[f]], y = d ? E.socket : pe(g, E.socket), P = w?.getDataOutput(y);
      if (!P) {
        S.warn(`[GraphCompiler] Cannot find output ${y} on node ${f}`);
        continue;
      }
      const T = s.blocks[c[l]], A = b ? m : X(p, m), k = T.getDataInput(A);
      k ? P.connectTo(k) : S.warn(`[GraphCompiler] Cannot wire value: node ${f}.${E.socket} → node ${l}.${m}`);
    }
  }
  for (let l = 0; l < e.nodes.length; l++) {
    const h = e.nodes[l];
    if (!h.flows) continue;
    const v = e.declarations[h.declaration], p = v?.op ?? "", b = !!v?.extensions?.TRACE_subgraph;
    for (const [m, E] of Object.entries(h.flows)) {
      const f = c[l], u = b ? m : de(p, m), d = !!e.declarations[e.nodes[E.node].declaration]?.extensions?.TRACE_subgraph, g = c[E.node], w = d ? E.socket : E.socket, y = s.blocks[f], P = s.blocks[g];
      if (!y || !P) continue;
      const T = y.getSignalOutput?.(u), A = P.getSignalInput?.(w);
      T && A ? T.connectTo(A) : S.warn(`[GraphCompiler] Cannot wire flow: node ${l}.${m}(${u}) → node ${E.node}.${E.socket}(${w})`);
    }
  }
  s.compilingGraphs.delete(t);
}
function Tt(e, t, s) {
  const n = /* @__PURE__ */ new Map(), r = [];
  e.nodes.forEach((i, a) => {
    const o = t[s[a]], c = i.configuration ? oe(i.configuration, "event") : 0;
    if (o instanceof vt) {
      let l = n.get(c);
      l || n.set(c, l = []), l.push(o);
    } else o instanceof bt && r.push({
      block: o,
      event: c
    });
  });
  for (const { block: i, event: a } of r) i.receivers = n.get(a) ?? [];
}
function Pt(e, t, s) {
  const n = s.compiledSubgraphs.get(e);
  if (n) return n;
  if (!St(s, e)) return null;
  const r = s.coordinator.createGraph(), i = [], a = {
    blocks: i,
    context: r.createContext(),
    coordinator: s.coordinator,
    scene: s.scene,
    traceScene: s.traceScene,
    contextObject: s.contextObject,
    allGraphs: s.allGraphs,
    compilingGraphs: s.compilingGraphs,
    invocationCounter: s.invocationCounter,
    compiledSubgraphs: s.compiledSubgraphs,
    selectTargets: s.selectTargets
  };
  for (const u of t.variables) a.context.setVariable(u.name, K(u, t.types));
  const o = [];
  for (let u = 0; u < t.nodes.length; u++) {
    const d = t.nodes[u], g = t.declarations[d.declaration];
    if (!g) {
      o.push(i.length), i.push(j());
      continue;
    }
    const w = g.extensions?.TRACE_subgraph;
    if (w) {
      const P = s.allGraphs[w.graph];
      if (P) {
        const T = Pt(w.graph, P, s);
        if (T) {
          const A = new mt({
            name: g.op,
            subgraphInterface: T.subgraphInterface,
            innerGraph: T.innerGraph,
            initContext: T.initContext
          });
          o.push(i.length), i.push(A);
          continue;
        }
      }
      o.push(i.length), i.push(j());
      continue;
    }
    const y = Et(g.op, d, t, s.contextObject, s.traceScene, s.selectTargets, "");
    if (!y) {
      o.push(i.length), i.push(j());
      continue;
    }
    o.push(i.length), xt(g.op, y), i.push(y);
  }
  Tt(t, i, o);
  const c = [];
  for (let u = 0; u < t.nodes.length; u++) {
    const d = t.nodes[u];
    if (!d.values) continue;
    const g = t.declarations[d.declaration]?.op ?? "";
    for (const [w, y] of Object.entries(d.values)) {
      if (!("node" in y)) {
        const G = i[o[u]].getDataInput(X(g, w));
        if (G) {
          const $ = K(y, t.types);
          G.setValue($, a.context), c.push({
            input: G,
            value: $
          });
        }
        continue;
      }
      const P = i[o[y.node]], T = i[o[u]];
      if (!P || !T) continue;
      const A = P.getDataOutput(pe(t.declarations[t.nodes[y.node].declaration]?.op ?? "", y.socket)), k = T.getDataInput(X(g, w));
      A && k && A.connectTo(k);
    }
  }
  for (let u = 0; u < t.nodes.length; u++) {
    const d = t.nodes[u];
    if (!d.flows) continue;
    const g = t.declarations[d.declaration]?.op ?? "";
    for (const [w, y] of Object.entries(d.flows)) {
      const P = i[o[u]], T = i[o[y.node]];
      if (!P || !T) continue;
      const A = P.getSignalOutput?.(de(g, w)), k = T.getSignalInput?.(y.socket);
      A && k && A.connectTo(k);
    }
  }
  for (const u of i) u instanceof he && r.addEventBlock(u);
  const l = On(t, i, o);
  En(l.outputFlowSockets), s.compilingGraphs.delete(e), s.invocationCounter = a.invocationCounter;
  const h = t.variables, v = t.types, p = [...c], { traceScene: b, contextObject: m } = s, f = {
    innerGraph: r,
    subgraphInterface: l,
    initContext: (u) => {
      Ve(u, b, m);
      for (const d of h) u.setVariable(d.name, K(d, v));
      for (const d of p) d.input.setValue(d.value, u);
    }
  };
  return s.compiledSubgraphs.set(e, f), f;
}
function On(e, t, s) {
  const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  if (e.inputFlowSockets) for (const [o, c] of Object.entries(e.inputFlowSockets)) {
    const l = t[s[c.node]];
    l instanceof Q && n.set(o, {
      block: l,
      signalName: c.socket
    });
  }
  if (e.outputFlowSockets) for (const [o, c] of Object.entries(e.outputFlowSockets)) {
    const l = t[s[c.node]], h = e.declarations[e.nodes[c.node]?.declaration]?.op ?? "";
    l instanceof Q && r.set(o, {
      block: l,
      signalName: de(h, c.socket)
    });
  }
  if (e.inputValueSockets) for (const [o] of Object.entries(e.inputValueSockets)) {
    const c = [];
    for (let l = 0; l < e.nodes.length; l++) {
      const h = e.nodes[l], v = e.declarations[h.declaration];
      if (!v) continue;
      const p = t[s[l]];
      if (!p) continue;
      const b = X(v.op, o);
      if (p.getDataInput(b)) {
        const m = h.values && o in h.values && !("node" in h.values[o]), E = !h.values || !(o in h.values);
        (m || E) && c.push({
          block: p,
          inputName: b
        });
      }
    }
    i.set(o, {
      connections: c,
      variableName: o
    });
  }
  if (e.outputValueSockets) for (const [o, c] of Object.entries(e.outputValueSockets)) {
    const l = t[s[c.node]], h = e.declarations[e.nodes[c.node]?.declaration]?.op ?? "";
    l && a.set(o, {
      block: l,
      outputName: pe(h, c.socket)
    });
  }
  return {
    inputFlowSockets: n,
    outputFlowSockets: r,
    inputValueSockets: i,
    outputValueSockets: a
  };
}
function Et(e, t, s, n, r, i, a) {
  const o = t.configuration ?? {};
  switch (e) {
    case _.EVENT_ON_SELECT: {
      const c = Pe(o, n, r);
      i.push(c);
      const l = new vs({ targetMesh: c.mesh });
      return c.follow(l.asset), l;
    }
    case _.EVENT_ON_HOVER_IN: {
      const c = Pe(o, n, r), l = new bs({ targetMesh: c.mesh });
      return c.follow(l.targetMesh), l;
    }
    case _.EVENT_ON_HOVER_OUT: {
      const c = Pe(o, n, r), l = new ys({ targetMesh: c.mesh });
      return c.follow(l.targetMesh), l;
    }
    case _.TRACE_ON_PROXIMITY:
      return new dn({ target: x(o, "target") });
    case _.EVENT_ON_START:
      return new Ue({
        eventId: "trace:start",
        eventData: {}
      });
    case _.EVENT_ON_TICK:
      return new Ss();
    case _.EVENT_SEND:
    case _.EVENT_RECEIVE: {
      const c = oe(o, "event"), l = s.events[c]?.id ?? "";
      return l === "" ? e === _.EVENT_SEND ? new bt(String(c)) : new vt() : e === _.EVENT_SEND ? new Wt({
        eventId: l,
        eventData: {}
      }) : new Ue({
        eventId: l,
        eventData: {}
      });
    }
    case _.POINTER_SET:
      return new vn({
        target: x(o, "target"),
        property: x(o, "property")
      });
    case _.POINTER_GET:
      return new yn({
        target: x(o, "target"),
        property: x(o, "property")
      });
    case _.POINTER_INTERPOLATE:
      return new Sn({
        target: x(o, "target"),
        property: x(o, "property")
      });
    case _.TRACE_SET_ACTIVE:
      return new zs({ target: x(o, "target") });
    case _.TRACE_SET_BEHAVIOR_ENABLED:
      return new Us({
        target: x(o, "target"),
        behavior: x(o, "behavior")
      });
    case _.TRACE_GET_ACTIVE:
      return new Ls({ target: x(o, "target") });
    case _.TRACE_GET_CHILD_COUNT:
      return new nn({ target: x(o, "target") });
    case _.TRACE_SET_ACTIVE_CHILD:
      return new rn({ target: x(o, "target") });
    case _.TRACE_GET_PROPERTY:
      return new an({
        target: x(o, "target"),
        property: x(o, "property")
      });
    case _.TRACE_TIME:
      return new cn();
    case _.TRACE_SET_PROPERTY:
      return new on({
        target: x(o, "target"),
        property: x(o, "property"),
        transition: kn(o, "transition")
      });
    case _.TRACE_SET_STATE:
      return new ln({ target: x(o, "target") });
    case _.TRACE_GET_STATE:
      return new un({ target: x(o, "target") });
    case _.TRACE_ON_STATE_CHANGE:
      return new hn({ target: x(o, "target") });
    case _.TRACE_PLAY_ANIMATION:
      return new Hs({
        target: x(o, "target"),
        clip: x(o, "clip") || void 0
      });
    case _.TRACE_PLAY_ANIMATION_EXTERNAL:
      return new Ws({
        target: x(o, "target"),
        src: x(o, "src"),
        clip: x(o, "clip") || void 0
      });
    case _.PAGES_NEXT:
      return new pn({ target: x(o, "target") });
    case _.PAGES_PREV:
      return new fn({ target: x(o, "target") });
    case _.PAGES_GET_ACTIVE_INDEX:
      return new gn({ target: x(o, "target") });
    case _.PAGES_GET_PAGE_COUNT:
      return new _n({ target: x(o, "target") });
    case _.TRACE_NAVIGATE:
      return new sn();
    case _.TRACE_PLAY_VIDEO:
      return new Xs({ target: x(o, "target") });
    case _.TRACE_PLAY_MEDIA:
      return new Ks({ target: x(o, "target") });
    case _.TRACE_PAUSE_MEDIA:
      return new Qs({ target: x(o, "target") });
    case _.TRACE_STOP_MEDIA:
      return new Zs({ target: x(o, "target") });
    case _.TRACE_SEEK_MEDIA:
      return new Ys({ target: x(o, "target") });
    case _.TRACE_SET_MEDIA_VOLUME:
      return new Js({ target: x(o, "target") });
    case _.TRACE_IS_MEDIA_PLAYING:
      return new en({ target: x(o, "target") });
    case _.TRACE_GET_MEDIA_VOLUME:
      return new tn({ target: x(o, "target") });
    case _.FLOW_BRANCH:
      return new Xt();
    case _.FLOW_SEQUENCE: {
      const c = (t.flows ? Object.keys(t.flows).map((l) => Number.parseInt(l, 10)) : []).reduce((l, h) => Number.isNaN(h) ? l : Math.max(l, h), -1);
      return new qt({ outputSignalCount: Math.max(2, c + 1) });
    }
    case _.FLOW_SET_DELAY:
      return new Kt();
    case _.FLOW_CANCEL_DELAY:
      return new Qt();
    case _.MATH_NOT:
      return new Jt({ valueType: me.Boolean });
    case _.MATH_AND:
      return new Yt({ valueType: me.Boolean });
    case _.MATH_OR:
      return new es({ valueType: me.Boolean });
    case _.MATH_EQ:
      return new ss();
    case _.MATH_GT:
      return new rs();
    case _.MATH_GE:
      return new is();
    case _.MATH_LT:
      return new as();
    case _.MATH_ADD:
      return new Zt();
    case _.MATH_SUB:
      return new ps();
    case _.MATH_MUL:
      return new us();
    case _.MATH_DIV:
      return new ts();
    case _.MATH_SELECT:
      return new ms();
    case _.MATH_MIN:
      return new ls();
    case _.MATH_MAX:
      return new cs();
    case _.MATH_POW:
      return new hs();
    case _.MATH_LE:
      return new os();
    case _.MATH_FLOOR:
      return new ns();
    case _.MATH_RANDOM:
      return new ds();
    case _.MATH_COMBINE3:
      return new fs();
    case _.VARIABLE_GET: {
      const c = oe(o, "variable");
      return new gs({ variable: a + (s.variables[c]?.name ?? `var_${c}`) });
    }
    case _.VARIABLE_SET: {
      const c = oe(o, "variable");
      return new _s({ variable: a + (s.variables[c]?.name ?? `var_${c}`) });
    }
    default:
      return null;
  }
}
function Pe(e, t, s) {
  return new $s(x(e, "target"), t, s);
}
function x(e, t) {
  const s = e[t];
  return !s || s.value.length === 0 ? "" : String(s.value[0]);
}
function oe(e, t) {
  const s = e[t];
  return !s || s.value.length === 0 ? 0 : Number(s.value[0]) || 0;
}
function kn(e, t) {
  const s = e[t];
  if (!s || s.value.length === 0) return;
  const n = s.value[0];
  return n !== null && typeof n == "object" && !Array.isArray(n) ? n : void 0;
}
function de(e, t) {
  if (e === _.TRACE_ON_PROXIMITY || e === _.TRACE_ON_STATE_CHANGE) return t;
  if (e.startsWith("trace/on") || e.startsWith("event/on")) return "done";
  if (e === _.FLOW_BRANCH) {
    if (t === "true") return "onTrue";
    if (t === "false") return "onFalse";
  }
  return e === _.FLOW_SEQUENCE ? `out_${t}` : e === _.FLOW_SET_DELAY && t === "err" ? "error" : t;
}
var wt = {
  [_.MATH_SELECT]: {
    a: "onTrue",
    b: "onFalse",
    value: "output"
  },
  [_.MATH_COMBINE3]: {
    a: "input_0",
    b: "input_1",
    c: "input_2"
  },
  [_.FLOW_SET_DELAY]: { lastDelay: "lastDelayIndex" },
  [_.FLOW_CANCEL_DELAY]: { delay: "delayIndex" }
};
function K(e, t) {
  const s = e.value.length === 1 && Array.isArray(e.value[0]) ? e.value[0] : e.value;
  if (s.length === 1) return s[0];
  switch (t[e.type]?.signature) {
    case "float2":
      return rt.FromArray(s);
    case "float3":
      return O.FromArray(s);
    case "float4":
      return H.FromArray(s);
    default:
      return s;
  }
}
function X(e, t) {
  return wt[e]?.[t] ?? t;
}
function pe(e, t) {
  return wt[e]?.[t] ?? t;
}
function xt(e, t) {
  const s = ne(e);
  if (!s) return;
  const n = t, r = [
    ...s.dataInputs.map((i) => [i.name, t.getDataInput(X(e, i.name))]),
    ...s.dataOutputs.map((i) => [i.name, t.getDataOutput(pe(e, i.name))]),
    ...s.flowInputs.map((i) => [i, n.getSignalInput?.(i)]),
    ...s.flowOutputs.map((i) => [i, n.getSignalOutput?.(de(e, i))])
  ];
  for (const [i, a] of r) if (!a) throw new Error(`Native block catalog mismatch: ${e}.${i} has no runtime connection`);
}
function j() {
  throw new Error("Graph compilation failed: invalid block passed executable-graph validation.");
}
var Cn = /* @__PURE__ */ new Set(), ai = class extends Z {
  static behaviorType = "BehaviorGraph";
  constructor(e, t) {
    super(e, Mt(t));
  }
  _compiled = null;
  getRuntimeDiagnostics() {
    if (this.khrManaged) return [];
    const e = this._resolved, t = e.graphs ?? (e.graph ? [e.graph] : []);
    if (!t.length) return [];
    const s = e.activeGraph ?? 0;
    return !Number.isInteger(s) || !t[s] ? [{
      code: "ACTIVE_GRAPH",
      field: "activeGraph",
      message: `Invalid active graph index ${s}.`
    }] : ke(t[s], t);
  }
  khrManaged = !1;
  _khrCoordinator = null;
  onPlayModeChanged(e) {
    if (e) try {
      this.khrManaged ? this._attachToKHRCoordinator() : this._buildAndStart();
    } catch (t) {
      S.warn(`[BehaviorGraph] Graph did not start: ${t instanceof Error ? t.message : String(t)}`);
    }
    else this._teardown();
  }
  selectTargets() {
    return this._compiled?.selectTargets ?? Cn;
  }
  validate(e) {
    e.graph && (e.graph = Re(e.graph)), e.graphs && (e.graphs = e.graphs.map((n) => Re(n)));
    const t = e.graphs ?? (e.graph ? [e.graph] : []);
    if (!this.playMode || this.khrManaged || !t.length) return [];
    const s = e.activeGraph ?? 0;
    return !Number.isInteger(s) || !t[s] ? [{
      code: "ACTIVE_GRAPH",
      field: "activeGraph",
      message: `Invalid active graph index ${s}.`
    }] : ke(t[s], t);
  }
  async applyCommit() {
    this.playMode && !this.khrManaged && this._buildAndStart();
  }
  onDetach() {
    this._teardown();
  }
  _attachToKHRCoordinator() {
    const e = this.sceneObject.babylonScene, t = at.SceneCoordinators.get(e);
    if (!t || t.length === 0) {
      S.warn("[BehaviorGraph] KHR-managed but no coordinator found — falling back to compiled mode"), this._buildAndStart();
      return;
    }
    this._khrCoordinator = t[0];
    for (const s of this._khrCoordinator.flowGraphs) for (let n = 0; ; n++) {
      const r = s.getContext(n);
      if (!r) break;
      Ve(r, this.sceneObject.traceScene, this.sceneObject);
    }
  }
  _buildAndStart() {
    const e = this.getRuntimeDiagnostics();
    if (e.length) throw new yt(e);
    const t = this._resolved, s = t.graphs ?? (t.graph ? [t.graph] : []), n = s[t.activeGraph ?? 0];
    if (!n || n.nodes.length === 0) {
      this._teardown(), S.log("[BehaviorGraph] Empty graph, nothing to run");
      return;
    }
    const r = xn(n, this.sceneObject.babylonScene, this.sceneObject.traceScene, this.sceneObject, s.length > 1 ? s : void 0);
    this._teardown(), this._compiled = r, r.coordinator.start();
    const i = this.sceneObject.traceScene, a = () => {
      this._compiled === r && r.fireEvent("trace:start");
    };
    i?._deferStartEvent ? i._deferStartEvent(a) : a();
  }
  _teardown() {
    this._compiled && (this._compiled.dispose(), this._compiled = null), this._khrCoordinator = null;
  }
}, oi = class extends Z {
  static behaviorType = "SphereCollider";
  _pickerMesh = null;
  getPickerMesh() {
    return this._pickerMesh;
  }
  onAttach(e) {
    this._createPickerMesh(e);
  }
  onDetach() {
    this._disposePickerMesh();
  }
  async applyCommit(e) {
    this.attachedNode && (this._disposePickerMesh(), this._createPickerMesh(this.attachedNode), this.sceneObject.traceScene.refreshMeshPickability?.(this.sceneObject));
  }
  setDebugVisible(e) {
    if (this._pickerMesh && (this._pickerMesh.visibility = e ? 0.3 : 0, e && !this._pickerMesh.material)) {
      const t = new Me(`${this.sceneObject.name}_collider_debug_mat`, this.sceneObject.babylonScene);
      t.diffuseColor = new Ee(0, 0.5, 1), t.wireframe = !0, this._pickerMesh.material = t;
    }
  }
  _createPickerMesh(e) {
    const t = this._resolved, s = t.radius ?? 0.5, n = t.center ?? [
      0,
      0,
      0
    ];
    S.debug(`[SphereCollider] Creating picker mesh for "${this.sceneObject.name}": radius=${s}, center=(${n[0]}, ${n[1]}, ${n[2]})`), this._pickerMesh = z.CreateSphere(`${this.sceneObject.name}${nt}`, {
      diameter: s * 2,
      segments: 16
    }, this.sceneObject.babylonScene), this._pickerMesh.position.set(n[0], n[1], n[2]), this._pickerMesh.parent = e, this._pickerMesh.visibility = 0, this._pickerMesh.isPickable = !0, S.debug(`[SphereCollider] Picker mesh created: "${this._pickerMesh.name}", isPickable=${this._pickerMesh.isPickable}`);
  }
  _disposePickerMesh() {
    this._pickerMesh && (this._pickerMesh.dispose(), this._pickerMesh = null);
  }
}, Mn = {
  add(e, t) {
    return {
      x: e.x + t.x,
      y: e.y + t.y,
      z: e.z + t.z
    };
  },
  subtract(e, t) {
    return {
      x: e.x - t.x,
      y: e.y - t.y,
      z: e.z - t.z
    };
  },
  scale(e, t) {
    return {
      x: e.x * t,
      y: e.y * t,
      z: e.z * t
    };
  },
  dot(e, t) {
    return e.x * t.x + e.y * t.y + e.z * t.z;
  },
  cross(e, t) {
    return {
      x: e.y * t.z - e.z * t.y,
      y: e.z * t.x - e.x * t.z,
      z: e.x * t.y - e.y * t.x
    };
  },
  length(e) {
    return Math.sqrt(e.x * e.x + e.y * e.y + e.z * e.z);
  },
  normalize(e) {
    const t = Math.sqrt(e.x * e.x + e.y * e.y + e.z * e.z);
    return t === 0 ? {
      x: 0,
      y: 0,
      z: 0
    } : {
      x: e.x / t,
      y: e.y / t,
      z: e.z / t
    };
  },
  lerp(e, t, s) {
    return {
      x: e.x + (t.x - e.x) * s,
      y: e.y + (t.y - e.y) * s,
      z: e.z + (t.z - e.z) * s
    };
  },
  distance(e, t) {
    const s = t.x - e.x, n = t.y - e.y, r = t.z - e.z;
    return Math.sqrt(s * s + n * n + r * r);
  },
  zero() {
    return {
      x: 0,
      y: 0,
      z: 0
    };
  },
  one() {
    return {
      x: 1,
      y: 1,
      z: 1
    };
  },
  up() {
    return {
      x: 0,
      y: 1,
      z: 0
    };
  },
  forward() {
    return {
      x: 0,
      y: 0,
      z: 1
    };
  },
  right() {
    return {
      x: 1,
      y: 0,
      z: 0
    };
  }
}, In = {
  clamp(e, t, s) {
    return Math.max(t, Math.min(s, e));
  },
  lerp(e, t, s) {
    return e + (t - e) * s;
  },
  inverseLerp(e, t, s) {
    return e === t ? 0 : (s - e) / (t - e);
  },
  remap(e, t, s, n, r) {
    const i = (e - t) / (s - t);
    return n + (r - n) * i;
  },
  degToRad(e) {
    return e * Math.PI / 180;
  },
  radToDeg(e) {
    return e * 180 / Math.PI;
  },
  random(e, t) {
    return e + Math.random() * (t - e);
  },
  randomInt(e, t) {
    return Math.floor(e + Math.random() * (t - e + 1));
  }
}, At = class extends Error {
  constructor(e) {
    super(`Script compilation failed:
${e.join(`
`)}`), this.violations = e, this.name = "ScriptCompileError";
  }
}, Bn = [
  "onStart",
  "onUpdate",
  "onDestroy",
  "onSelect",
  "onSelectExit",
  "onHover",
  "onHoverExit",
  "onEvent"
], Nn = [
  [/^\s*import\s+(?!type\b)/gm, "Runtime import statements are forbidden (use `import type` for types)"],
  [/\brequire\s*\(/g, "`require()` is forbidden"],
  [/\beval\s*\(/g, "`eval()` is forbidden"],
  [/\bnew\s+Function\s*\(/g, "`new Function()` is forbidden"],
  [/\bsetTimeout\s*\(/g, "`setTimeout()` is forbidden"],
  [/\bsetInterval\s*\(/g, "`setInterval()` is forbidden"],
  [/\brequestAnimationFrame\s*\(/g, "`requestAnimationFrame()` is forbidden"],
  [/\bglobalThis\b/g, "`globalThis` is forbidden"],
  [/\bwindow\b/g, "`window` is forbidden"],
  [/\bdocument\b/g, "`document` is forbidden"],
  [/\bprocess\b/g, "`process` is forbidden"],
  [/^\s*export\s+enum\b/gm, "`enum` declarations are forbidden (use string unions or const objects)"],
  [/^\s*enum\b/gm, "`enum` declarations are forbidden (use string unions or const objects)"],
  [/^\s*namespace\b/gm, "`namespace` declarations are forbidden"],
  [/^\s*export\s+namespace\b/gm, "`namespace` declarations are forbidden"]
];
function Vn(e) {
  const t = [];
  for (const [s, n] of Nn)
    s.lastIndex = 0, s.test(e) && t.push(n);
  return t;
}
function Rn(e) {
  const t = e.split(`
`), s = [];
  let n = !1, r = 0;
  for (let i = 0; i < t.length; i++) {
    const a = t[i], o = a.trim();
    if (/^\s*import\s+type\s+/.test(a)) continue;
    if (n) {
      for (const l of a)
        l === "{" && r++, l === "}" && r--;
      r <= 0 && (n = !1, r = 0);
      continue;
    }
    if (/^\s*(export\s+)?interface\s+/.test(o)) {
      const l = (a.match(/\{/g) || []).length, h = (a.match(/\}/g) || []).length;
      l > h && (n = !0, r = l - h);
      continue;
    }
    if (/^\s*(export\s+)?type\s+\w+/.test(o)) {
      const l = (a.match(/\{/g) || []).length, h = (a.match(/\}/g) || []).length;
      l > h && (n = !0, r = l - h);
      continue;
    }
    const c = Fn(a);
    s.push(c);
  }
  return s.join(`
`);
}
function Fn(e) {
  let t = e;
  return t = t.replace(/\bas\s+[a-zA-Z][\w<>,\s|&[\]]*(?=[,;)\]\s}]|$)/g, ""), t = t.replace(/(\w+)\s*<[A-Z][\w<>,\s|&[\]]*>\s*\(/g, "$1("), t = t.replace(/\)\s*:\s*[A-Z][\w<>,\s|&[\].]*(?=\s*\{|$)/g, ")"), t = t.replace(/\)\s*:\s*(?:void|string|number|boolean|Promise<[^>]*>|[\w<>,\s|&[\].]+)(?=\s*\{|$)/g, ")"), t = t.replace(/((?:const|let|var)\s+\w+)\s*:\s*\{[^}]*\}\s*(?==)/g, "$1 "), t = t.replace(/((?:const|let|var)\s+\w+)\s*:\s*[\w<>,|&[\].']+\s*(?==)/g, "$1 "), t = Dn(t), t;
}
function Dn(e) {
  let t = e;
  return !/\bfunction\b|=>/.test(t) && !/^\s*\(/.test(t) || (t = t.replace(/(\w+)\??\s*:\s*(?:Readonly<[^>]*>|[\w<>,\s|&[\].]+?)(?=\s*[,)=])/g, "$1")), t;
}
function Gn(e) {
  let t = e;
  t = t.replace(/^export\s+async\s+function\s+/gm, "async function "), t = t.replace(/^export\s+function\s+/gm, "function "), t = t.replace(/^export\s+const\s+/gm, "const "), t = t.replace(/^export\s+let\s+/gm, "let "), t = t.replace(/^export\s+var\s+/gm, "var ");
  const s = Bn.map((r) => `if (typeof ${r} === 'function') __exports.${r} = ${r};`).join(`
`), n = `
'use strict';
var __exports = {};
${t}
${s}
return __exports;
`;
  return new Function("Math", "JSON", "fetch", "XMLHttpRequest", "WebSocket", "Vec3", "MathUtil", n)(Math, JSON, fetch, XMLHttpRequest, WebSocket, Mn, In);
}
function Ce() {
  const e = {
    get(t, s) {
      if (typeof s != "symbol")
        return !isNaN(Number(s)) || s === "deltaTime" || s === "elapsed" || s === "x" || s === "y" || s === "z" || s === "w" ? 0 : s === "name" || s === "path" ? "" : s === "active" || s === "isPlaying" ? !1 : s === "valueOf" ? () => 0 : s === "toString" ? () => "" : new Proxy(function() {
        }, {
          apply() {
            return Ce();
          },
          get(n, r) {
            return e.get({}, r, n);
          }
        });
    },
    set() {
      return !0;
    }
  };
  return new Proxy({}, e);
}
function ci(e) {
  const t = [];
  let s;
  try {
    s = e();
  } catch (n) {
    return t.push(`Factory error: ${n instanceof Error ? n.message : String(n)}`), t;
  }
  for (const n of [
    "onStart",
    "onUpdate",
    "onDestroy",
    "onSelect",
    "onSelectExit",
    "onHover",
    "onHoverExit"
  ]) {
    const r = s[n];
    if (r)
      try {
        r(Ce());
      } catch (i) {
        const a = i instanceof Error ? i.message : String(i);
        t.push(`${n}: ${a}`);
      }
  }
  if (s.onEvent) try {
    s.onEvent(Ce(), "test");
  } catch (n) {
    const r = n instanceof Error ? n.message : String(n);
    t.push(`onEvent: ${r}`);
  }
  return t;
}
function $n(e) {
  const t = Vn(e);
  if (t.length > 0) throw new At(t);
  const s = Rn(e);
  return () => Gn(s);
}
function Ln(e) {
  const t = /export\s+interface\s+Data\s+extends\s+BehaviorData\s*\{/.exec(e);
  if (!t) return null;
  let s = 1, n = t.index + t[0].length;
  const r = n;
  for (; n < e.length && s > 0; )
    e[n] === "{" && s++, e[n] === "}" && s--, s > 0 && n++;
  return e.slice(r, n);
}
function jn(e) {
  return e.replace(/([A-Z])/g, " $1").replace(/^./, (t) => t.toUpperCase()).trim();
}
function Un(e) {
  const t = /* @__PURE__ */ new Map(), s = e.match(/\/\*\*\s*([\s\S]*?)(?=\s*@|\s*\*\/)/);
  if (s) {
    const i = s[1].replace(/^\s*\*\s?/gm, "").trim();
    i && t.set("description", i);
  }
  const n = /@(\w+)\s*([\s\S]*?)(?=\s*@\w|\s*\*\/)/g;
  let r;
  for (; (r = n.exec(e)) !== null; ) {
    const i = r[1], a = r[2].replace(/^\s*\*\s?/gm, "").trim();
    t.set(i, a);
  }
  return t;
}
function zn(e) {
  const t = [], s = e.split(`
`);
  let n = "", r = !1;
  for (const i of s) {
    const a = i.trim();
    if (a.startsWith("/**")) {
      r = !0, n = a, a.endsWith("*/") && (r = !1);
      continue;
    }
    if (r) {
      n += `
` + a, a.includes("*/") && (r = !1);
      continue;
    }
    const o = a.match(/^(\w+)(\??)\s*:\s*(.+?)\s*;?\s*$/);
    if (o) {
      const c = o[1], l = o[2] === "?", h = o[3], v = n ? Un(n) : /* @__PURE__ */ new Map();
      n = "", t.push({
        key: c,
        typeText: h,
        optional: l,
        jsdoc: v
      });
      continue;
    }
    if (a.match(/^['"]@type['"]/) || a.match(/^['"]@/)) {
      n = "";
      continue;
    }
    r || a === "" || a.startsWith("//");
  }
  return t;
}
function Hn(e, t) {
  const s = e.trim();
  return s === "number" ? { fieldType: "number" } : s === "boolean" ? { fieldType: "boolean" } : s === "string" ? t.toLowerCase().includes("color") ? { fieldType: "color" } : { fieldType: "string" } : s.match(/^['"]([^'"]+)['"](\s*\|\s*['"][^'"]+['"])*$/) ? {
    fieldType: "enum",
    options: s.split("|").map((n) => n.trim().replace(/^['"]|['"]$/g, ""))
  } : /^\[number\s*,\s*number\s*,\s*number\]$/.test(s) ? { fieldType: "vec3" } : s.includes("x:") && s.includes("y:") && s.includes("z:") ? { fieldType: "vec3" } : { fieldType: "string" };
}
function Wn(e) {
  return e && (e.startsWith('"') && e.endsWith('"') || e.startsWith("'") && e.endsWith("'") ? e.slice(1, -1) : e);
}
function Xn(e) {
  if (e = e.trim(), e.startsWith('"') && e.endsWith('"') || e.startsWith("'") && e.endsWith("'")) return e.slice(1, -1);
  if (e === "true") return !0;
  if (e === "false") return !1;
  const t = parseFloat(e);
  if (!isNaN(t)) return t;
  if (e.startsWith("{") || e.startsWith("[")) try {
    const s = e.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
    return JSON.parse(s);
  } catch {
  }
  return e;
}
function Je(e) {
  const t = Ln(e);
  if (!t) return [];
  const s = zn(t), n = [];
  for (const r of s) {
    if (r.key === "@type" || r.jsdoc.has("hidden") || r.jsdoc.has("deprecated")) continue;
    const { fieldType: i, options: a } = Hn(r.typeText, r.key), o = {
      key: r.key,
      label: Wn(r.jsdoc.get("label")) || jn(r.key)
    };
    switch (r.jsdoc.has("default") && (o.default = Xn(r.jsdoc.get("default"))), r.jsdoc.has("description") && (o.description = r.jsdoc.get("description")), r.optional && o.default === void 0 && i !== "number" && (o.optional = !0), i) {
      case "number": {
        const c = r.jsdoc.has("step") ? parseFloat(r.jsdoc.get("step")) : 0.01;
        n.push({
          ...o,
          type: "number",
          step: c,
          default: o.default ?? 0
        });
        break;
      }
      case "enum":
        n.push({
          ...o,
          type: "enum",
          options: a
        });
        break;
      case "boolean":
        n.push({
          ...o,
          type: "boolean"
        });
        break;
      case "color":
        n.push({
          ...o,
          type: "color"
        });
        break;
      case "vec3":
        n.push({
          ...o,
          type: "vec3"
        });
        break;
      default:
        n.push({
          ...o,
          type: "string"
        });
        break;
    }
  }
  return n;
}
var li = class {
  _factories = /* @__PURE__ */ new Map();
  _errors = /* @__PURE__ */ new Map();
  _schemas = /* @__PURE__ */ new Map();
  _executionEnabled = !0;
  _registrationStarted = !1;
  get executionEnabled() {
    return this._executionEnabled;
  }
  disableExecution() {
    if (this._executionEnabled) {
      if (this._registrationStarted) throw new Error("Disable script execution before registering or loading scripts");
      this._executionEnabled = !1;
    }
  }
  register(e, t) {
    if (this._registrationStarted = !0, !this._executionEnabled) {
      this._schemas.set(e, Je(t));
      return;
    }
    try {
      const s = $n(t);
      this._factories.set(e, s);
      const n = Je(t);
      this._schemas.set(e, n), S.log(`[ScriptRegistry] Registered script: ${e} (${n.length} fields)`);
    } catch (s) {
      const n = s instanceof At ? s.violations.join("; ") : String(s);
      this._errors.set(e, n), S.error(`[ScriptRegistry] Failed to compile ${e}: ${n}`);
    }
  }
  getFactory(e) {
    return this._factories.get(e);
  }
  isScriptType(e) {
    return this._factories.has(e) || this._errors.has(e) || this._schemas.has(e);
  }
  getError(e) {
    return this._errors.get(e);
  }
  getSchema(e) {
    return this._schemas.get(e);
  }
  createBehavior(e, t, s) {
    const n = this._factories.get(t);
    if (!n && (this._executionEnabled || !this._schemas.has(t))) return null;
    const r = { "@type": t }, i = r, a = this._schemas.get(t);
    if (a)
      for (const c of a) c.default !== void 0 && (i[c.key] = structuredClone(c.default));
    if (s)
      for (const [c, l] of Object.entries(s)) l !== void 0 && (i[c] = l);
    const o = new Ct(e, r, n);
    return o.load(), o;
  }
  clear() {
    this._factories.clear(), this._errors.clear(), this._schemas.clear();
  }
};
export {
  ti as $,
  Js as A,
  Ns as B,
  rn as C,
  Qs as D,
  en as E,
  zs as F,
  Ms as G,
  Ne as H,
  Us as I,
  si as J,
  Is as K,
  ii as L,
  Xs as M,
  Ws as N,
  Ks as O,
  Hs as P,
  ei as Q,
  js as R,
  nn as S,
  tn as T,
  ni as U,
  ri as V,
  le as W,
  Cs as X,
  ks as Y,
  Os as Z,
  un as _,
  yt as a,
  on as b,
  Sn as c,
  gn as d,
  _n as f,
  hn as g,
  dn as h,
  ai as i,
  Zs as j,
  Ys as k,
  yn as l,
  fn as m,
  ci as n,
  wn as o,
  pn as p,
  ye as q,
  oi as r,
  ke as s,
  li as t,
  vn as u,
  ln as v,
  sn as w,
  an as x,
  cn as y,
  Ls as z
};

//# sourceMappingURL=ScriptRegistry-C3vqndus.js.map